<template>
  <div>
     <div class="mpart1">
  <div class="mpart1-1">
    <div class="mpart1-1Title">

       
        <h1 class="mpart1Title">Реализованные проекты</h1>
    </div>
    <p class="mpart1p">Наши клиенты могут быть уверены в том, что мы предлагаем наивысшее качество услуг и всегда стремимся предложить самые инновационные решения.</p>
    <p class="mpart1pp"> <span style="text-decoration:underline;"> <router-link  style="text-decoration: none; color:black;" to="Home"> Главная</router-link></span> / <span style="opacity:0.5;"> Производство</span></p>
  </div>    
</div>
    <div class="container-fluid">
      <div class="row">
        
        <div class="col-md-12 col-lg-12 col-sm-12 part1Margin">
           <div class="part2line-1"></div>
          <swiper class="swiper" :options="swiperOptions">
            <swiper-slide>
              <div class="coverImgCarousel8">
                <!-- <img src="../assets/img/Home/image 288.png" /> -->
                <div class="carouselMain" style="">
                    <img style=" margin-right:5rem; color:white; z-index:24;"
                         class="home-icon"
                          src="@/assets/img/Home/2carousel/ico1.svg"
                          alt="section_2_bg_overlay"
                          
                        />
                        <div style=" z-index:33;width:80%"> 
                  <p class="part8mainTitle">
                 Строительство торгового центра.<br> Использование металлоконструкций в <br> каркасных технологиях.
                </p>
                <p class="part8mainTitlep">
                  Складское каркасно-тентовое здание двухскатного типа р-ром 28х66м. Строительство склада “под ключ”
                </p>
                        </div>
                </div>
                
                
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
        <hr class="project-line"/>
    <div class="part2">

      <div class="part2item-1">
        <div style="position: relative; left: 0; top: 0;">
        <img class="metal-pic decorative-image-2 fishes" src="../assets/img/1pr.png" alt="">
        <img class=" fish" src="../assets/img/ico_flash.png" alt="">
    </div>
      </div>
      <div class="part2item-2">
        <h3 class="project-text">Декоративное фонарное освещение в городе.</h3>
        <hr/>
        <h6 class="part2Title2">
          Декоративные опоры востребованы при организации наружного освещения парков, аллей, придомовых территорий, бульваров, развлекательных центров, загородных паселков и других объектов.
        </h6>
         <!-- <button class="button-project">Подробнее о проекте <img style="margin-left:3rem;" src="../assets/Right.svg" alt="" /></button> -->
      </div>
     
    </div>
    
     <div class="part2">
      
      <div class="part2item-2">
        <div style="position: relative; left: 0; top: 0;">
        <img class="metal-pic decorative-image-2 fishes" src="../assets/img/2pr.png" alt="">
        <img class=" fish" src="../assets/img/ico_baryer.png" alt="">
    </div>
      </div>
      <div class="part2item-1">
        <h3 class="project-text">Парковочные барьеры на территории нового торгового развлекательного центра.</h3>
        <hr/>
        <h6 class="part2Title2">
          Установка парковочных барьеров широко распространена во дворах жилых домов, возле магазинов и супермаркетов, офисных зданий, ресторанов, кинотеатров, торговых и развлекательных центров.
        </h6>
      </div>
    </div>
    <div class="part2">
      
      <div class="part2item-1 mb-5">
        <div style="position: relative; left: 0; top: 0;">
        <img class="metal-pic decorative-image-2 fishes" src="../assets/img/3pr.png" alt="">
        <img class=" fish" src="../assets/img/ico_bench.png" alt="">
    </div>
      </div>
      <div class="part2item-2">
        <h3 class="project-text middle-section-pr">Установка уличных скамеек и урн на территории парка Tashkent City</h3>
        <hr/>
        <h6 class="part2Title2">
          Современные урны уличные металлические – достойно решают проблему борьбы за чистоту города, улиц, парков, территорий торговых и офисных центров, предприятий общественного питания, придомовых территорий и других мест повышенной посещаемости. 
        </h6>
      </div>
    </div>



   
    
   

    
    <div class="part12">
      <div class="part12-0">
        <div class="part12-0Line"></div>
      </div>
      <div class="part12-1">
        <div class="part12-1Line"></div>
      </div>
      <div class="part12-2">
        <div class="part12-2InfoLine"></div>
        <h4 class="part12-2Info">Обратная связь</h4>
      </div>
      <div class="part12-3">
        <h1 class="part12-3T ">
          Заполните форму обратной <br />
          связи и мы оперативно<br />
          свяжемся с вами !
        </h1>
      </div>
      <div class="part12-4">
       <b-form @submit="onSubmit" v-if="show" class="row" action="../../public/test.php"  method="POST">
      <b-form-group class="col-md-6 form-metalix">
        <b-form-input class="form-metalix-1" label="name"
          id="input-1"
          v-model="name"
          type="name"
          placeholder="Ваша имя"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group  class="col-md-6 form-metalix">
        <b-form-input class="form-metalix-1" label="surname"
          id="input-2"
          v-model="surname"
          type="surname"
          placeholder="Ваша фамилия"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group class="col-md-6 form-metalix">
        <b-form-input class="form-metalix-1" label="email"
          id="input-3"
          v-model="email"
          type="email"
          placeholder="Ваша почта"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group  class="col-md-6 form-metalix">
        <b-form-input class="form-metalix-1" label="phone"
          id="input-4"
          v-model="phone"
          type="phone"
          placeholder="Ваш номер"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group  class="form-metalix">
        <b-form-input class="form-metalix-1" label="message"
          id="input-5"
          v-model="message"
          type="message"
          placeholder="Комментария"
          
        ></b-form-input>
      </b-form-group>
        <div style="display: flex; width:50%;">
          <input type="checkbox" checked  style="width:30px; height:50px; margin-right:3rem;">
          <p style="color:white;"> Я согласен на обработку<br/>персональных данных.  </p>
         
        </div>

      <b-button data-submit="...Sending" @click="showAlert" class="col-md-6 form-metalix-1 sending-btn" type="submit"  variant="primary">Отправить заявку</b-button>
    </b-form>
      </div>
      <div class="part12-5">
        <div class="part12TitleLine"></div>
        <p class="part12Tp">
          В разделе “комментарий” вы можете указать удобное для вас время когда
          мы можем с вами связаться.
        </p>
      </div>
      <div class="part12-6">
        <p class="part12Tp2">
          Мы не занимаемся рассылкой рекламных сообщений, а также не передаем
          контактные данные третьим лицам !
        </p>
      </div>
    </div>
    <div class="part13">
      <div class="part13-0">
        <div class="part13-0L"></div>
        <h4 class="part13-0T">Контакты</h4>
      </div>
      <div class="part13-1">
        <div class="part13-1Line"></div>
      </div>
      <div class="part13-2">
        <h1 class="part13T">
          Мы благодарны Вам за проявленный интерес к нашей компании.
        </h1>
      </div>
      <div class="part13-3">
        <p class="part13Tp">
          Вы также можете получить консультацию по интересующим вас вопросам в
          любое время или приехать к нам в офис.
        </p>
      </div>
      <div class="part13-4">
        <div class="part13-4Line"></div>
        <div class="row">
          <div class="col-sm-12 part13AdressInfo">
            <img
            width="24px" height="24px"
              class="part13AdresInfoimg"
              src="../assets/img/location.svg"
              alt=""
            />
            <ul class="part13-4Address">
              <li>г.Ташкент, Сергели</li>
              <li> ул.Нилуфар 77/7, 100155</li>
            </ul>
          </div>
          <div class="col-sm-12" style="display: flex">
            <img
            width="24px" height="24px"
              class="part13AdresInfoimg"
              src="../assets/img/phone.svg"
              alt=""
            />
            <ul class="part13-4PhoneUl">
              <li>+998 97 108 4444</li>
              <li>+998 97 109 4444</li>
            </ul>
          </div>
          <div class="col-sm-12 email-footer" style="display: flex; margin-top: 40px">
            <img width="24px" height="24px" src="../assets/img/mail.svg" alt="" />
            <p class="part13-4mailp">info@metalix.uz</p>
          </div>
          <div class="col-sm-12">
            <ul class="part13-4PhoneUl2">
              <li>По вопросам партнерства</li>
              <li>+998 90 334 35 00</li>
              <li>info@metalix.uz</li>
            </ul>
          </div>
          <!-- <div class="col-sm-12">
            <div class="socialTag" style="display: flex">
              <img class="part13icon" src="../assets/img/tgb.svg" alt="" />
              <p class="part13-4mailp2">Telegram</p>
            </div>
            <div class="socialn socialTag">
              <img class="part13icon" src="../assets/img/fbb.svg" alt="" />
              <p class="part13-4mailp2">Facebook</p>
            </div>
            <div class="socialn socialTag">
              <img class="part13icon" src="../assets/img/Inb.svg" alt="" />
              <p class="part13-4mailp2">Instagram</p>
            </div>
          </div> -->
        </div>
      </div>
      <div class="part13-5">
        <div class="mapouter">
          <div class="gmap_canvas">
          
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2970.6581975340723!2d69.25022158783936!3d41.20638627079112!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x702a9595707bb6f!2zNDHCsDEyJzIyLjkiTiA2OcKwMTUnMDguNyJF!5e0!3m2!1sru!2s!4v1636694271660!5m2!1sru!2s" width="100%" height="886" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
            <!-- <iframe
              class="gmap_iframe"
              width="100%"
              frameborder="0"
              scrolling="no"
              marginheight="0"
              marginwidth="0"
              src="https://maps.google.com/maps?width=1112&amp;height=886&amp;hl=en&amp;q=tashkent&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
              style="padding: 0 auto"
            ></iframe> -->
            <!-- https://goo.gl/maps/BcKh4QETzn99XK7E9 -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { directive } from "vue-awesome-swiper";
import axios from 'axios';
import "swiper/swiper-bundle.css";
export default {
  data() {
      return {
        form: {
          name: '',
          surname: '',
          email: '',
          phone: '',
          message: '',
        },
        // foods: [{ text: 'Select One', value: null }, 'Carrots', 'Beans', 'Tomatoes', 'Corn'],
        show: true,
      }
    },
    methods: {
      onSubmit(event) {
        event.preventDefault()
        let data = new FormData(); 
    
 
    data.append('name', this.name) 
    data.append('surname', this.surname) 
    data.append('email', this.email) 
    data.append('phone', this.phone) 
    data.append('message', this.message)
    console.log(data)
        axios.post('../../public/test.php', data)

    .then((data) => {Swal.fire({
  position: 'center',
  icon: 'success',
  iconColor: 'red',
  title: 'Отправлено !',
  showConfirmButton: false,
  timer: 1500
});console.log(data)})
    .catch(error => {

       
        console.error('There was an error!', error);
        this.$swal('Error');
    });
      },
      


      showAlert(){
			
  
 
  
			
		},
    },
   components: {
    // VueSlickCarousel,
    // Carousel, Slide
   
  },
  directives: {
    swiper: directive,
  }, 
      mounted () {
  window.scrollTo(0, 0)
}


}
// import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";

// import "swiper/swiper-bundle.css";
// export default {
//   name: "HelloWorld",

//   components: {
//     Swiper,
//     SwiperSlide,
//   },
//   directives: {
//     swiper: directive,
//   },
//   props: {
//     msg: String,
//   },
//   data() {
//     return {
//       swiperOptions: {
//         observer: true,
//         observeParents: true,
//         parallax: true,
//         pagination: {
//           el: ".swiper-pagination",
//           type: "fraction",
//         },
//         navigation: {
//           nextEl: ".swiper-button-next",
//           prevEl: ".swiper-button-prev",
//         },
//       },
//       swiperOption: {
//         slidesPerView: 3,
//         spaceBetween: 0,
//         pagination: {
//           el: ".swiper-pagination",
//           clickable: true,
//           type: "fraction",
//         },
//         navigation: {
//           nextEl: ".swiper-button-next",
//           prevEl: ".swiper-button-prev",
//         },
//         breakpoints: {
//           1024: {
//             slidesPerView: 3,
//             spaceBetween: 0,
//           },
//           768: {
//             slidesPerView: 3,
//             spaceBetween: 0,
//           },
//           640: {
//             slidesPerView: 2,
//             spaceBetween: 0,
//           },
//           320: {
//             slidesPerView: 1,
//             spaceBetween: 0,
//           },
//         },
//       },
//       settings: {
//         dots: true,
//         focusOnSelect: true,
//         infinite: true,
//         speed: 500,
//         slidesToShow: 3,
//         slidesToScroll: 1,
//         touchThreshold: 5,
//       },
//       car1: [
//         '<div class="example-slide">Slide 1</div>',
//         '<div class="example-slide">Slide 2</div>',
//         '<div class="example-slide">Slide 3</div>',
//       ],
//     };
//   },
//   computed: {
//     swiper() {
//       return this.$refs.mySwiper.$swiper;
//     },
//   },
//   mounted() {
//     window.scrollTo(0, 0)
//     console.log("Current Swiper instance object", this.swiper);
//     this.swiper.slideTo(3, 1000, false);
//   },
//   methods: {
//     onChange(a, b, c) {
//       console.log(a, b, c);
//     },

//     navigationNext() {
//       console.log("navigationNext");
//       return `<img src="../assets/Left.svg"/>`;
//     },
//     navigationPrev() {
//       console.log("navigationPrev");
//       return `<img src="../assets/Right.svg"/>`;
//     },
//     navigationHandler() {
//       console.log("navigationHandler");
//     },
//     SlideCarousel(value) {
//       console.log("SlideCarousel:", value);
//       const carouselx = this.$refs["productDetails"][0];
//       const currentPage = carouselx.currentPage;
//       const pageCount = carouselx.pageCount;
//       if (value == "prev") {
//         currentPage != 0
//           ? carouselx.goToPage(currentPage - 1)
//           : carouselx.goToPage(pageCount - 1);
//       } else {
//         currentPage < pageCount - 1
//           ? carouselx.goToPage(currentPage + 1)
//           : carouselx.goToPage(0);
//       }
//     },
//   },
// };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.product-type {
  /* bottom: -5px; */
  /* position: absolute; */
  /* display: block; */

  height: 647px;
  /* overflow: hidden; */
  background-repeat: no-repeat;
  /* background-size: 100%; */
  /* display: inline-block; */
  /* background-position: 50% 50%; */
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.8s ease-in-out;
}
.swiper-button-prev, .swiper-button-next{
  color: white !important;
}
.fishes
    {
      position: relative;
      top: 0;
      left: 0;
      /* width: 400px; */
    }
    .fish
    {
      position: absolute;
      top: 40px;
      left: 6%;
      width: 150px;
      height:150px;
      /* position: fixed; */
    }
    .project-text{
      font-family: Inter;
font-style: normal;
font-weight: 600;
font-size: 32px;
line-height: 48px;
/* or 150% */
text-align: left;
letter-spacing: 0.05em;

/* metalix (ligtt,text) */

color: #36454F;

    }
.product-type-2 {
  bottom: -5px;
  /* position: absolute; */
  /* display: block; */

  height: 284px;
  /* overflow: hidden; */
  background-repeat: no-repeat;
  background-size: 100%;
  /* display: inline-block; */
  background-position: 50% 50%;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.8s ease-in-out;
}
.form-metalix {
  margin-bottom: 5rem;
}
.form-metalix-1{
  height: 80px;
}
.sending-btn{
  width: 400px;
  margin-left: 15px !important;
  background-color: white;
  border: none;
  font-family: Styrene A LC;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: #272a2e;
}
.ugolok-inner-picture {
  height: 500px;
  background-repeat: no-repeat;
  background-size: cover;
}
.product-type-img {
  z-index: 2;
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  -webkit-transition: transform 0.8s linear;
  -moz-transition: transform 0.8s linear;
  -o-transition: transform 0.8s linear;
  transition: transform 0.8s linear;
}

.product-type-bg-overlay {
  right: 0;
}
.clear {
  clear: both;
}
.productListIconImage {
  position: absolute;
  width: 144px;
  height: 144px;
  margin-top: -36vh;
  margin-left: 10rem;
  z-index: 26;
  box-shadow: 0px 2px 3px black;
}
.productListh2 {
  position: absolute;
  margin-top: -16vh;
  margin-left: 5rem;
  font-weight: bold;
  color: white;
  z-index: 26;
  text-shadow: 1px 1px 1px black;
}
.whiteBox {
  position: relative;
  width: 152px;
  height: 2px;
  background: #36454f;
  z-index: 19;
  margin-top: -60px;
  margin-left: 150px;
  /*
  position:fixed;
  width: 456px;
  height: 34px;
  background: #FBFBFB;
  bottom:0;
  left:0;
  margin-bottom: 6px;
  margin-left : 0px;
  z-index: 64;
  */
}
#sppage {
  /* position:absolute; */
  /* position:fixed; 
  bottom:0;
  left:0;
  margin-bottom: 35px;
  margin-left : 145px;
  z-index: 65 !important;
  background: #36454F;
   /* margin: 0 auto;
   margin-top:305 !important; *
  margin-bottom: 5px !important;
   /* border: 1px solid red; *
   width: 162px !important;
   height: 2px !important;
   */
  /* margin-top: 105px; 
background: #b4c0cf !important;

padding-top:0 auto !important;
padding-bottom: 5px !important;
*/
}

.minipart5-4 {
  text-align: left;
}
.minipart5-4 img {
  margin-left: 20px;
}
.swiper-pagination .swiper-pagination-fraction .swiper-pagination-current {
  display: inline-block !important;
  margin-top: 50% !important;
  padding: 30px;
}
.inputMar {
 margin-left:152px;
  /* margin-right: 36px; */
}
.socialn {
  margin-bottom: 32px;
  display: flex;
  margin-top: 16px;
}
.swiper-pagination {
  position: absolute;
  text-align: center;
  transition: 300ms opacity;
  transform: translate3d(0, 0, 0);
  z-index: 10;
  background: #fbfbfb;
  color: black;
  width: 456px;
  height: 120px;
  margin-bottom: -4px;
  margin-left: 0px;
}
.mpart1-1Title {
  margin-left: -2rem;
}
.swiper-pagination-fraction {
  /* color: red !important; */
  padding-top: 50px;
  /* border: 1px solid red; */
}

.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-container-horizontal > .swiper-pagination-current {
  bottom: 10px;
  left: 0;
  /* width: 100%; */

  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 12px;
  /* identical to box height, or 100% */

  letter-spacing: 2px;
  text-transform: uppercase;

  color: #36454f !important;
}
/* .swiper-pagination-fraction, */
/* .swiper-pagination-custom, */
/* .swiper-container-horizontal >  */

.swiper-pagination-current {
  margin-left: -115px;
  /* display: inline-block;
    vertical-align: bottom; */
}
.mpart1pp{
    height: 120px;
    margin-top: 0px;
    margin-bottom: 30px;
text-align: left;
font-family: Inter;
font-style: normal;
font-weight: 500;
font-size: 16px;
line-height: 40px;
/* or 167% */
margin-left: -5rem;
letter-spacing: 0.1em;
text-indent: 32px;

/* metalix (ligtt,text) */

color: #36454F;
}
.mpart1p {
  margin-left: -3rem;
}


.coverImgCarousel2 {
  position: relative;
  display: inline-block;
  width: 100%;
}
.coverImgCarousel2::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: -moz-radial-gradient(
    83.12% 398.5% at 79.31% 100%,
    rgba(35, 59, 87, 0) 0%,
    #233b57 100%
  ); /* FF3.6+ */
  background: -webkit-radial-gradient(
    83.12% 398.5% at 79.31% 100%,
    rgba(35, 59, 87, 0) 0%,
    #233b57 100%
  ); /* Chrome,Safari4+ *
  background: -webkit-radial-gradient(
    83.12% 398.5% at 79.31% 100%,
    rgba(35, 59, 87, 0) 0%,
    #233b57 100%
  ); /* Chrome10+,Safari5.1+ */
  background: -o-radial-gradient(
    83.12% 398.5% at 79.31% 100%,
    rgba(35, 59, 87, 0) 0%,
    #233b57 100%
  ); /* Opera 11.10+ */
  background: -ms-radial-gradient(
    83.12% 398.5% at 79.31% 100%,
    rgba(35, 59, 87, 0) 0%,
    #233b57 100%
  ); /* IE10+ */
  background: radial-gradient(
    83.12% 398.5% at 79.31% 100%,
    rgba(35, 59, 87, 0) 0%,
    #233b57 100%
  ); /* W3C */
  /* filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#002f4b', endColorstr='#00000000',GradientType=0 );  */
  /* rgba(35, 59, 87, 0) 0%,
    #233b57 100% */
  /* ); */
  mix-blend-mode: normal;
  opacity: 0.48;
}
.coverImgCarousel img {
  display: block;
  /* filter:grayscale(1) */
}
.infoBlockTitle {
  width: 100%;
  min-height: 30px;
}
.mainTitlep {
  position: absolute;
  width: 696px;
  height: 112px;

  text-align: left;
  position: absolute;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 40px;
  /* or 167% */

  letter-spacing: 0.1em;

  color: #fbfbfb;
}
.carouselMain{
position:absolute; 
display:flex;
width: 100%;
height: 100%;
 justify-content:space-evenly;
 align-items: flex-start;
 padding: 15vh 5vw;
}
.swiper-button-next {
  left: 392px;
  right: auto;
  bottom: 39px;
  top: auto;
  color: #36454f;
  z-index: 30;
}
.swiper-button-prev {
  left: 32px;
  right: auto;
  bottom: 39px !important;
  top: auto;
  z-index: 30;
  color: #36454f;
}
.swiper-button-prev {
  bottom: 0;
  background-image: url("../assets/Left.svg") !important;
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-position: center;
}

.swiper-button-prev::after {
  display: none;
}
.part1Margin{
  margin-left: 8.8%;
    width: 91%;
    
}
.project-line{
  width: 89.5%;
  margin-left: 9.5%;
  margin-top: 4rem;
  margin-bottom: -3rem;
}
.swiper-button-next {
  background-image: url("../assets/Right.svg") !important;
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-position: center;
}

.swiper-button-next::after {
  display: none;
}
/************** */
.productSlider .swiper-button-next {
  left: 392px;
  right: auto;
  bottom: 39px;
  top: auto;
  color: yellow !important;
  z-index: 30;
}
.productSlider .swiper-button-prev {
  left: 32px;
  right: auto;
  bottom: 39px !important;
  top: auto;
  z-index: 30;
  color: #74fc06 !important;
}
.productSlider .swiper-button-prev {
  bottom: 0;
  background-image: url("../assets/Left.svg") !important;
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-position: center;
  background: yellow !important;
}

/* .productSlider .swiper-button-prev::after {
  display: none;
} */

.productSlider .swiper-button-next {
  background-image: url("../assets/Right.svg") !important;
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-position: center;
  background: yellow !important;
}

/* .productSlider .swiper-button-next::after {
  display: none;
} */
/************** */
.slick-slider {
  width: 100%;
  max-width: 720px;
}
.slick-slider {
  width: 100%;
  max-width: 720px;
}
.Carouselbox {
  position: relative;
  top: 0;
  left: 0;
}

.mainImgc {
  position: relative;
  top: 0;
  left: 0;
}
.coverImgCarousel {
  position: relative;
  display: inline-block;
  width: 100%;
}
.coverImgCarousel::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: -moz-radial-gradient(
    83.12% 398.5% at 79.31% 100%,
    rgba(35, 59, 87, 0) 0%,
    #233b57 100%
  ); /* FF3.6+ */
  background: -webkit-radial-gradient(
    83.12% 398.5% at 79.31% 100%,
    rgba(35, 59, 87, 0) 0%,
    #233b57 100%
  ); /* Chrome,Safari4+ */
  background: -webkit-radial-gradient(
    83.12% 398.5% at 79.31% 100%,
    rgba(35, 59, 87, 0) 0%,
    #233b57 100%
  ); /* Chrome10+,Safari5.1+ */
  background: -o-radial-gradient(
    83.12% 398.5% at 79.31% 100%,
    rgba(35, 59, 87, 0) 0%,
    #233b57 100%
  ); /* Opera 11.10+ */
  background: -ms-radial-gradient(
    83.12% 398.5% at 79.31% 100%,
    rgba(35, 59, 87, 0) 0%,
    #233b57 100%
  ); /* IE10+ */
  background: radial-gradient(
    83.12% 398.5% at 79.31% 100%,
    rgba(35, 59, 87, 0) 0%,
    #233b57 100%
  ); /* W3C */
  /* filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#002f4b', endColorstr='#00000000',GradientType=0 );  */
  /* rgba(35, 59, 87, 0) 0%,
    #233b57 100% */
  /* ); */
  mix-blend-mode: normal;
  opacity: 0.48;
}
.coverImgCarousel2 {
  position: relative;
  display: inline-block;
  width: 100%;
}
.coverImgCarousel2::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: -moz-radial-gradient(
    83.12% 398.5% at 79.31% 100%,
    rgba(35, 59, 87, 0) 0%,
    #233b57 100%
  ); /* FF3.6+ */
  background: -webkit-radial-gradient(
    83.12% 398.5% at 79.31% 100%,
    rgba(35, 59, 87, 0) 0%,
    #233b57 100%
  ); /* Chrome,Safari4+ */
  background: -webkit-radial-gradient(
    83.12% 398.5% at 79.31% 100%,
    rgba(35, 59, 87, 0) 0%,
    #233b57 100%
  ); /* Chrome10+,Safari5.1+ */
  background: -o-radial-gradient(
    83.12% 398.5% at 79.31% 100%,
    rgba(35, 59, 87, 0) 0%,
    #233b57 100%
  ); /* Opera 11.10+ */
  background: -ms-radial-gradient(
    83.12% 398.5% at 79.31% 100%,
    rgba(35, 59, 87, 0) 0%,
    #233b57 100%
  ); /* IE10+ */
  background: radial-gradient(
    83.12% 398.5% at 79.31% 100%,
    rgba(35, 59, 87, 0) 0%,
    #233b57 100%
  ); /* W3C */
  /* filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#002f4b', endColorstr='#00000000',GradientType=0 );  */
  /* rgba(35, 59, 87, 0) 0%,
    #233b57 100% */
  /* ); */
  mix-blend-mode: normal;
  opacity: 0.48;
}
.coverImgCarousel img {
  display: block;
  /* filter:grayscale(1) */
}
.infoBlockTitle {
  width: 100%;
  min-height: 30px;
}
.mainTitlep {
  position: absolute;
  width: 696px;
  height: 112px;

  text-align: left;
  position: absolute;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 40px;
  /* or 167% */

  letter-spacing: 0.1em;

  color: #fbfbfb;
}
.part8mainTitlep {
  position: absolute;
  /* width: 100%; */
  height: 112px;
font-family: Inter;
font-style: normal;
font-weight: normal;
font-size: 18px;
line-height: 24px;
/* identical to box height, or 171% */
margin-top: 13rem;
letter-spacing: 0.05em;

/* _Light */

color: #FBFBFB;


}

#first .VueCarousel-navigation-next::before {
  background: url("../assets/Left.svg");
  right: 6px;
}

#first .VueCarousel-navigation-next {
  z-index: 4 !important;
  margin-right: 1315px !important;
  margin-top: 280px !important;
}
#first .VueCarousel-navigation-prev {
  margin-top: 280px !important;
  margin-left: 50px !important;
  z-index: 4 !important;
}
#first .VueCarousel-navigation-prev::before {
  background: url("../assets/Right.svg");
  left: 6px;
}
/****th */
#th .VueCarousel-navigation-next::before {
  background: url("../assets/Left.svg");
  right: 6px;
}
#th .VueCarousel-navigation-next {
  z-index: 4 !important;
  margin-right: 135px !important;
  margin-top: -530px !important;
}
#th .VueCarousel-navigation-prev {
  margin-top: -530px !important;
  margin-left: 1365px !important;
  z-index: 4 !important;
}
#th .VueCarousel-navigation-prev::before {
  background: url("../assets/Right.svg");
  left: 6px;
}
/****sec */
#sec {
  width: 1700px;
}
#sec .VueCarousel-navigation-next::before {
  background: url("../assets/Left.svg");
  right: 6px;
}
#sec .VueCarousel-navigation-next {
  z-index: 4 !important;
  margin-right: 70px !important;
  margin-top: -540px !important;
}
#sec .VueCarousel-navigation-prev {
  margin-top: -540px !important;
  margin-left: 1565px !important;
  z-index: 4 !important;
}
#sec .VueCarousel-navigation-prev::before {
  background: url("../assets/Right.svg");
  left: 6px;
}
/* #first  .VueCarousel-pagination{
     margin-left: 0;
     margin-right: auto;
    
   }
 #first  .VueCarousel-pagination{
    width: 456px !important;
    margin-top: -102px !important;
    z-index: 3 !important;
       height: 103px !important;
  background: #fbfbfb !important;
} */
/* .VueCarousel-dot-container{
 
    width: 456px !important;
  
}
 .VueCarousel-pagination .VueCarousel-dot {
 background-color: #787b81 !important;
      
 }


.VueCarousel-pagination .VueCarousel-dot--active {
      background-color: blue !important;
} */
.mapouter {
  position: relative;
  text-align: right;
  width: 100%;
  height: 886px;
}
.gmap_canvas {
  overflow: hidden;
  background: none !important;
  width: 100%;
  /* height: 903px !important; */
}
.gmap_iframe {
  height: 903px !important;
}
@font-face {
  font-family: "Inter";
  src: url("~@/assets/font/Inter-Regular.ttf");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Inter";
  src: url("~@/assets/font/Inter-SemiBold.ttf");
  font-weight: 600;
  font-style: normal;
}

.metalP {
  /* width: 1720px; */
  height: 592px;
  background: #f6f6f6;
  margin-top: 48px;
  margin-bottom: 184px;
}
.ftManufac {
  width: 272px;
  height: 40px;

  font-family: Styrene A LC;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 40px;
  /* identical to box height, or 333% */

  display: flex;
  align-items: center;
  letter-spacing: 0.05em;
  text-transform: uppercase;

  color: #353b50;

  opacity: 0.25;
}
ul.ftMtextul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  text-align: left;
}
.ftMtext {
  width: 240px;
  height: 16px;
  margin-top: 24px;
  margin-left: 15px;
  font-family: Styrene A LC;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  /* identical to box height, or 133% */

  letter-spacing: 0.1em;

  color: #353b50;
}
.ftabout {
  width: 272px;
  height: 40px;
  font-family: Styrene A LC;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 40px;
  /* identical to box height, or 333% */

  display: flex;
  align-items: center;
  letter-spacing: 0.05em;
  text-transform: uppercase;

  color: #353b50;
}
.part4navB {
  margin-top: 256px;
}
.part5leftLine {
  width: 164px;
  height: 2px;
  margin-top: 180px;
  margin-left: 1px;
  background: #272a2e;
  /* line */

  box-shadow: inset 1px 0px 0px #36454f;
  transform: rotate(-90deg);
}
.part5left {
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  /* identical to box height, or 200% */
  margin-left: -3px;
  letter-spacing: 0.25em;
  text-transform: uppercase;

  /* metalix (ligtt,text) */

  color: #36454f;

  transform: rotate(-90deg);
}
.part5line1 {
  width: 120px;
  height: 1px;
  /* margin-left: 162px; */
  margin-top: 108px;
  margin-bottom: 99px;
  background: #b4c0cf;
}
.part5Line {
  width: 392px;
  height: 4px;
  margin-bottom: 92px;

  /* metalix (ligtt,text) */

  background: #36454f;
}
.part5MiniBlockT {
  width: 392px;
  height: 80px;

  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 40px;
  /* or 167% */
  text-align: left;
  letter-spacing: 0.1em;
  margin: 16px 24px 48px 24px;
  /* metalix (ligtt,text) */

  color: #36454f;
}
.part5MiniBlockIcon {
  margin-bottom: 152px;
}
.part5MiniBlockP {
  width: 392px;
  min-height: 160px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 32px;
  /* or 229% */
  margin: 48px 24px 48px 24px;
  letter-spacing: 0.1em;
  text-indent: 24px;

  /* metalix (ligtt,text) */

  color: #36454f;
}
.part5Title {
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  margin-top: 99px;
  margin-left: 0;
  margin-right: 80px;
  margin-bottom: 96px;
  /* or 150% */
  text-align: left;
  letter-spacing: 0.1em;
  text-indent: 32px;

  /* metalix (ligtt,text) */

  color: #36454f;
}
.infoBlock {
  display: flex;
  /* justify-content: space-around; */
  margin-bottom: 96px;
}
.infoBlockh {
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  /* identical to box height, or 133% */

  letter-spacing: 0.1em;
  margin-left: 48px;
  /* metalix (ligtt,text) */

  color: #36454f;
}
.infoBlockP {
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 32px;
  /* or 200% */
  text-align: left;
  margin-top: 40px;
  margin-left: 48px;
  letter-spacing: 0.1em;
  text-indent: 24px;
  min-height: 170px;
  /* metalix (ligtt,text) */

  color: #36454f;
}
.part3Line {
  /* metalix (ligtt,text) */
  width: 164px;
  height: 2px;
  background: #36454f;
  /* line */
  margin-top: 170px;
  margin-left: 7px;
  box-shadow: inset 1px 0px 0px #36454f;
  transform: rotate(-90deg);
}
.part3about {
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  /* identical to box height, or 200% */
  margin-top: 115px;

  letter-spacing: 0.25em;
  text-transform: uppercase;

  /* metalix (ligtt,text) */

  color: #36454f;

  transform: rotate(-90deg);
}

.part4h3 {
  width: 392px;
  height: 80px;
  margin-top: 0px;
  margin-left: 116px;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 40px;
  /* or 222% */

  letter-spacing: 0.1em;
  text-indent: 32px;

  /* _Light */

  color: #fbfbfb;
}
.part4h {
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  /* or 150% */
  text-align: left;
  letter-spacing: 0.1em;
  width: 100%;
  /* _Light */
  margin-top: 0px;
  /* margin-left: 65px; */
  margin-bottom: 120px;
  color: #fbfbfb;
}
.part4rec {
  width: 164px;
  height: 2px;
  background: #fcfdff;
  /* line */
  margin-top: 250px;
  margin-left: -13px;
  box-shadow: inset 1px 0px 0px #36454f;
  transform: rotate(-90deg);
}
.part4about {
  text-align: center;
  width: 365px;
  height: 24px;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  /* identical to box height, or 200% */
  margin-left: -112px;
  letter-spacing: 0.25em;
  text-transform: uppercase;

  /* line (darck) */

  color: #b4c0cf;

  transform: rotate(-90deg);
}
.part10 {
  display: grid;
  grid-template-columns: 200px 1fr;
  grid-auto-rows: minmax(824, auto);
  background: #36454f;
}

.part10-1 {
  grid-column: 1/2;
  grid-row: 1/2;
  display: block;
}

.part10-2 {
  grid-column: 2/4;
  grid-row: 1/2;
}
.part10Info {
  width: 153px;
  height: 24px;
  margin-left: 5px;
  margin-top: 180px;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  /* identical to box height, or 200% */

  letter-spacing: 0.25em;

  color: #b4c0cf;

  transform: rotate(-90deg);
}
.part10InfoLine {
  width: 164px;
  height: 2px;
  margin-top: 195px;
  background: #b4c0cf;
  transform: rotate(-90deg);
}

.part12Infotextarea {
  background: #fbfbfb;
  /* _Light */
  margin-top: 48px;
  margin-left: 0px;
  width: 52em;
  height: 80px;
  border: 1px solid #fbfbfb;
  box-sizing: border-box;
  resize: none;
}
::-webkit-input-placeholder {
  color: #c1c1c1;
  vertical-align: middle;
  text-align: center;
}
:-moz-placeholder {
  /* Firefox 18- */
  color: #c1c1c1;
  vertical-align: middle;
  text-align: center;
}
::-moz-placeholder {
  /* Firefox 19+ */
  color: #c1c1c1;
  vertical-align: middle;
  text-align: center;
}
:-ms-input-placeholder {
  color: #c1c1c1;
  vertical-align: middle;
  text-align: center;
}
.part12InfoButton {
  width: 392px;
  height: 80px;
  margin-left: 12px;
  background: #cfd3d6;
  box-shadow: 0px 4px 32px #575d65;
}
#fname {
  width: 392px;
  height: 64px;

  /* _Light */

  background: #fbfbfb;
  /* _Light */

  border: 1px solid #fbfbfb;
  box-sizing: border-box;
}
.part12Checkp {
  width: 310px;
  height: 48px;
  text-align: left;

  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */
  margin-left: 50px;
  letter-spacing: 0.1em;

  /* _Light */

  color: #fbfbfb;
}
#part12Check {
  width: 32px;
  height: 32px;
  background-color: #36454f !important;
  /* Light (darck) 02 */

  border: 1px solid #9dafbc;
  box-sizing: border-box;
  border-radius: 1.5px;
}
.part12InfoBT {
  font-family: Styrene A LC;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  /* identical to box height, or 200% */

  text-align: center;
  letter-spacing: 2px;
  text-transform: uppercase;

  /* Metalix_darck */

  color: #272a2e;
}
.part12InfoLine {
  width: 830px;
  height: 1px;
  margin-bottom: 63px;
  /* _Light */
  margin-top: 63px;
  background: #fbfbfb;
  opacity: 0.16;
  margin-left: .8rem;
}
.part12InfoMust {
  width: 532px;
  height: 24px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  margin-top: 40px;
  margin-bottom: 104px;
  margin-left: 15px;
  letter-spacing: 0.1em;

  /* _Light */

  color: #fbfbfb;
}
/************part13 */
.part13 {
  display: grid;
  grid-template-columns: 200px 1fr 1fr 1fr 1fr 1fr 0.5fr;
  grid-auto-rows: minmax(1136, auto);
  background: #fbfbfb;
}
.part13-0 {
  grid-column: 1/2;
  grid-row: 3/3;
}
.part13-1 {
  grid-column: 2/4;
  grid-row: 1/2;
}
.part13-2 {
  grid-column: 2/4;
  grid-row: 2/2;
}
.part13-3 {
  grid-column: 5/7;
  grid-row: 2/3;
}
.part13-4 {
  grid-column: 2/4;
  grid-row: 3/3;
}
.part13-5 {
  grid-column: 4/8;
  grid-row: 3/3;
}
.part13-4Line {
  width: 392px;
  height: 4px;

  /* _Text */

  background: #233b57;
}
.part13icon {
  margin-top: -15px;
}
.part13AdressInfo {
  display: flex;
  margin-top: 84px;
}
.part13-4Address {
  width: 336px;
  height: 48px;
  margin-top: 35px;
  text-align: left;
  list-style-type: none;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */

  letter-spacing: 0.15em;

  /* Text */

  color: #233b57;
}
.part13-4PhoneUl2 {
  width: 336px;
  height: 96px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 32px;
  /* or 200% */
  margin-left: 28px;
  list-style-type: none;
  letter-spacing: 0.15em;
  margin-bottom: 105px;
  margin-top: 88px;
  /* active(bottom) */

  color: #d19258;
}
.part13-4mailp2 {
  width: 336px;
  height: 24px;

  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  text-align: left;
  margin-left: 28px;
  /* margin-top: 15px; */
  letter-spacing: 0.15em;

  /* Text */

  color: #233b57;
}
.part13-4mailp {
  width: 336px;
  height: 24px;

  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  text-align: left;
  letter-spacing: 0.15em;
  margin-left: 30px;
  /* Text */

  color: #233b57;
}
.part13-4PhoneUl {
  width: 336px;
  height: 72px;
  margin-top: 45px;
  text-align: left;
  list-style-type: none;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */

  letter-spacing: 0.15em;

  /* Text */

  color: #233b57;
}
.part13-0T {
  width: 128px;
  height: 24px;
  margin-top: 15px;
  margin-left: 36px;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  /* identical to box height, or 200% */

  letter-spacing: 0.25em;
  text-transform: uppercase;

  /* _Text */

  color: #233b57;

  transform: rotate(-90deg);
}
.part13-0L {
  width: 200px;
  height: 2px;
  margin-top: 150px;
  margin-bottom: 200px;
  /* _Text */

  background: #233b57;
  transform: rotate(-90deg);
}
.part13-1Line {
  width: 120px;
  height: 1px;
  margin-top: 108px;
  margin-bottom: 99px;

  background: #b4c0cf;
}
.part13T {
  width: 715px;
  height: 96px;

  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  /* or 150% */

  letter-spacing: 0.1em;
  margin-bottom: 96px;
  /* Text */

  text-align: left;
  color: #233b57;
}
.part13Tp {
  width: 696px;
  height: 80px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 40px;
  /* or 222% */

  letter-spacing: 0.1em;
  text-indent: 32px;

  /* Text */

  color: #233b57;
}
/**************part12 */
.part12 {
  display: grid;
  grid-template-columns: 200px 1fr 1fr 1fr 1fr 1fr;
  grid-auto-rows: minmax(1136, auto);
  background: #36454f;
}
.part12-0 {
  grid-column: 2/4;
  grid-row: 1/2;
}
.part12-1 {
  grid-column: 5/6;
  grid-row: 1/2;
}
.part12-2 {
  grid-column: 1/2;
  grid-row: 1/7;
}
.part12-3 {
  grid-column: 2/4;
  grid-row: 2/3;
}
.part12-4 {
  grid-column: 5/5;
  grid-row: 2/5;
}
.part12-5 {
  grid-column: 2/4;
  grid-row: 3/4;
}
.part12-6 {
  grid-column: 2/4;
  grid-row: 4/6;
}
.part12TitleLine {
  width: 392px;
  height: 4px;
  margin-top: 96px;
  margin-bottom: 76px;
  /* _Light */

  background: #fbfbfb;
}
.part12Tp {
  width: 392px;
  height: 96px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 32px;
  /* or 200% */

  letter-spacing: 0.1em;

  /* _Light */

  color: #fbfbfb;
}
.part12Tp2 {
  width: 392px;
  height: 96px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 32px;
  /* or 200% */
  margin-top: 72px;
  margin-bottom: 104px;
  letter-spacing: 0.1em;

  /* _Light */

  color: #fbfbfb;
}
.part12-0Line {
  width: 120px;
  height: 2px;
  margin-top: 108px;
  margin-bottom: 99px;
  /* _Light */

  background: #fbfbfb;
}
.part12-1Line {
  width: 830px;
  height: 2px;

  margin-top: 108px;
  margin-bottom: 99px;
  /* _Light */

  background: #fbfbfb;
  opacity: 0.16;
}
.part12-2Info {
  margin-top: 180px;
  width: 247px;
  height: 24px;
  margin-left: -23px !important;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  /* identical to box height, or 200% */

  letter-spacing: 0.25em;
  text-transform: uppercase;

  /* line (darck) */

  color: #b4c0cf;
  margin-left: -43px;
  transform: rotate(-90deg);
}
.part12-2InfoLine {
  width: 164px;
  height: 2px;
  margin-top: 190px;
  margin-left:18px;
  background: #4b5a64;
  /* line */

  box-shadow: inset 1px 0px 0px #36454f;
  transform: rotate(-90deg);
}
.part12-3T {
  width: 543px;
  height: 144px;
  margin-top: 0;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  /* or 150% */

  letter-spacing: 0.1em;

  /* _Light */

  color: #fbfbfb;
}
/***part12 */
.part11 {
  display: grid;
  grid-template-columns: 200px 1fr 1fr 1fr 1fr 1fr 0.5fr;
  grid-auto-rows: minmax(1136, auto);
  background: #fafafa;
  margin-top: 235px;
}
.part11Line {
  margin-top: 108px;
  margin-left: 232px;
  margin-bottom: 99px;
  width: 120px;
  height: 1px;

  background: #b4c0cf;
}
.part11Info {
  width: 79px;
  height: 24px;

  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  /* identical to box height, or 200% */

  letter-spacing: 0.25em;
  text-transform: uppercase;

  /* _Text */
  margin-top: -180px;
  margin-left: 42px;
  color: #233b57;

  transform: rotate(-90deg);
}
.part11InfoLine {
  display: inline-block;
  width: 164px;
  height: 2px;
  margin-top: 180px;
  /* _Text */
  margin-left: -30px;
  background: #233b57;
  transform: rotate(-90deg);
}
.part11-1 {
  grid-column: 1/2;
  grid-row: 3/7;
  display: block;
}
.part11-2 {
  grid-column: 2/5;
  grid-row: 2/7;
}
.part11-3 {
  grid-column: 5/7;
  grid-row: 2/7;
}
.part11-4 {
  grid-column: 2/3;
  grid-row: 3/7;
}

.part11-5 {
  grid-column: 3/4;
  grid-row: 3/7;
}
.part11-6 {
  grid-column: 4/5;
  grid-row: 3/7;
}
.part11-7 {
  grid-column: 5/6;
  grid-row: 3/7;
}

.part11-8 {
  grid-column: 6/7;
  grid-row: 3/3;
}
.part11Imargin {
  margin-top: 120px;
}
.part11BP {
  height: 192px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 32px;
  /* or 229% */

  letter-spacing: 0.1em;
  text-indent: 24px;

  /* _Text */

  color: #233b57;
}
.part11BTitle {
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
  /* or 160% */
  height: 128px;
  letter-spacing: 0.1em;
  text-align: left;
  /* _Text */
  margin-top: 92px;
  margin-bottom: 32px;
  color: #233b57;
}
.part11BTitle2 {
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
  /* or 160% */
  height: 128px;
  letter-spacing: 0.1em;
  text-align: left;
  /* _Text */
  margin-left: 43px;
  margin-top: 32px;
  margin-bottom: 88px;
  color: #233b57;
}
.part11DateText {
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  /* identical to box height, or 171% */

  letter-spacing: 0.05em;

  /* Text */

  color: #233b57;

  opacity: 0.32;

  /* Inside Auto Layout */

  flex: none;
  order: 0;
  flex-grow: 0;
}
.part11Date {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 4px 16px;
  margin-bottom: 32px;

  width: 140px;
  height: 32px;
  background: #ebf2f0;
}
.part11Date2 {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 4px 16px;
  margin-bottom: 32px;

  margin-left: 43px;
  width: 140px;
  height: 32px;
  background: #ebf2f0;
}
.part11B {
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 20px;
  /* identical to box height, or 200% */

  text-align: center;
  letter-spacing: 2px;
  text-transform: uppercase;
  width: 544px;
  color: #233b57;
  height: 64px;
  background: transparent;
  border: 1px solid #233b57;
  box-sizing: border-box;
}
.part11BlockLine2 {
  width: 240px;
  height: 2px;
  margin-top: 32px;
  margin-bottom: 23px;
  margin-left: 43px;
  background: #b4c0cf;
  opacity: 0.32;
}
.part11BlockLine {
  width: 240px;
  height: 1px;
  margin-top: 120px;

  margin-bottom: 23px;
  background: #b4c0cf;
  opacity: 0.32;
}
.part11Title {
  height: 196px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  /* or 150% */

  letter-spacing: 0.1em;

  /* _Text */

  color: #233b57;
}
/******part8 */
.part8 {
  display: grid;
  grid-template-columns: 200px 2fr 0.5fr 0.5fr 0.5fr;
  grid-auto-rows: minmax(472, auto);
  background: #ffffff;
}
.part8-0 {
  grid-column: 2/4;
  grid-row: 1/2;
}
.part8-1 {
  grid-column: 1/2;
  grid-row: 3/4;
  display: block;
}

.part8-2 {
  grid-column: 2/4;
  grid-row: 2/2;
}

.part8-3 {
  grid-column: 4/5;
  grid-row: 2/2;
}

.part8-4 {
  grid-column: 5/6;
  grid-row: 2/2;
}

.part8-5 {
  grid-column: 2/6;
  grid-row: 3/4;
}
.part8InfoLine {
  display: inline-block;
  width: 164px;
  height: 2px;
  margin-top: 120px !important;
  margin-left: -13px;
  /* metalix (ligtt,text) */

  background: #36454f;
  transform: rotate(-90deg);
}
.part8Line {
  width: 120px;
  height: 1px;
  margin-left: 232px;
  margin-top: 108px;
  margin-bottom: 99px;
  background: #b4c0cf;
}
.part8Margin {
  margin-bottom: 40px;
  margin-top: 40px;
}
.part8Title {
  width: 80%;
  height: 96px;
  margin-bottom: 104px;
  margin-left: 175px;
  margin-right: 32px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  /* or 150% */

  letter-spacing: 0.1em;
  text-indent: 32px;

  /* metalix (ligtt,text) */

  color: #36454f;
}
/**************8part end */
.partInfoT {
  width: 78px;
  height: 24px;
  margin-left: 31px;
  margin-top: 32px;
  margin-bottom: 32px;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  /* identical to box height, or 200% */

  letter-spacing: 0.25em;
  text-transform: uppercase;

  /* metalix (ligtt,text) */

  color: #36454f;

  transform: rotate(-90deg);
}

.part6BlockTitle {
  width: 392px;
  min-height: 72px;
  text-align: left;
  /* margin-bottom: 48px; */
  margin-top: 48px;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 40px;
  /* identical to box height, or 167% */

  letter-spacing: 0.1em;

  /* metalix (ligtt,text) */

  color: #36454f;
}
.part6BlockP {
  width: 392px;
  /* height: 96px; */
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 32px;
  /* or 229% */
  margin-bottom: 128px;
  letter-spacing: 0.1em;
  text-indent: 24px;

  /* metalix (ligtt,text) */

  color: #36454f;
}
.part6Line {
  width: 392px;
  height: 4px;
  margin-bottom: 108px;
  /* _Text */

  background: #233b57;
}
.part6P {
  width: 596px;
  margin-top: 208px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 40px;
  /* or 222% */
  margin-left: 368px;
  letter-spacing: 0.1em;
  text-indent: 32px;

  /* metalix (ligtt,text) */

  color: #36454f;
}
.part6Title {
  width: 543px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 56px;
  line-height: 64px;
  /* or 114% */
  margin-top: 208px;
  margin-bottom: 96px;
  letter-spacing: 0.1em;

  /* metalix (ligtt,text) */

  color: #36454f;
}
.part6 {
  display: grid;
  grid-template-columns: 200px 2fr 0.5fr 2fr 0.5fr 2fr 0.2fr;
  grid-auto-rows: minmax(472, auto);
  background: #fbfbfb;
}
.part6-0 {
  grid-column: 2/2;
  grid-row: 2/2;
}
.part6-1 {
  grid-column: 1/2;
  grid-row: 2/5;
}

.part6-2 {
  grid-column: 2/2;
  grid-row: 1/2;
}

.part6-3 {
  grid-column: 4/7;
  grid-row: 1/2;
}

.part6-4 {
  grid-column: 2/3;
  grid-row: 3/3;
  text-align: left;
}
.part6-5 {
  grid-column: 4/5;
  grid-row: 3/3;
  text-align: left;
}
.part6-6 {
  grid-column: 6/7;
  grid-row: 3/3;
  text-align: left;
}
.part6-7 {
  grid-column: 2/3;
  grid-row: 4/4;

  text-align: left;
}
.part6-8 {
  grid-column: 4/5;
  grid-row: 4/4;

  text-align: left;
}
.part6InfoLine {
  margin-top: 220px;

  width: 164px;
  height: 2px;
  margin-left: 1px;
  /* metalix (ligtt,text) */

  background: #36454f;
  /* line */

  box-shadow: inset 1px 0px 0px #36454f;
  transform: rotate(-90deg);
}
.part6Info {
  width: 298px;
  height: 24px;
  margin-left: -66px;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  /* identical to box height, or 200% */

  letter-spacing: 0.25em;
  text-transform: uppercase;

  /* metalix (ligtt,text) */

  color: #36454f;

  transform: rotate(-90deg);
}

.part7 {
  display: grid;
  grid-template-columns: 200px 2fr 0.5fr 2fr 0.5fr 2fr 0.2fr;
  grid-auto-rows: minmax(472, auto);
  background: #272d31;
}
.part7-0 {
  grid-column: 2/4;
  grid-row: 1/2;
}
.part7-1 {
  grid-column: 1/2;
  grid-row: 1/2;
}

.part7-2 {
  grid-column: 2/4;
  grid-row: 2/2;
}

.part7-3 {
  grid-column: 4/7;
  grid-row: 2/2;
}

.part7-4 {
  grid-column: 2/4;
  grid-row: 3/3;
}
.part7-5 {
  grid-column: 4/7;
  grid-row: 3/3;
}
.part7-6 {
  grid-column: 2/5;
  grid-row: 4/4;
  margin-bottom: 72px;
}
.part7-7 {
  grid-column: 5/7;
  grid-row: 4/4;
}
.part7Title {
  width: 696px;
  height: 112px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 56px;
  /* or 140% */
  margin: 88px 0px;
  letter-spacing: 0.1em;

  /* _Light */

  color: #fbfbfb;
}
.part7BI {
  position: absolute;
  margin-left: 170px;
  margin-right: 0;
  color: #fbfbfb;
}
.part7Button {
  width: 544px;
  margin-left: 150px;
  height: 65px;
  color: #fbfbfb;
  background: transparent;
  border: 1px solid #fbfbfb;
  box-sizing: border-box;
}
.part7P2 {
  width: 696px;
  height: 120px;
  left: 232px;
  top: 408px;

  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 40px;
  /* or 167% */

  letter-spacing: 0.1em;
  text-align: left;
  /* _Light */
  margin-bottom: 112px;
  color: #fbfbfb;
}
.part7P {
  /* width: 696px; */
  margin-left: 316px;
  height: 120px;
  text-align: left;

  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 40px;
  /* or 222% */
  margin-top: 88px;
  margin-bottom: 88px;
  letter-spacing: 0.1em;
  text-indent: 32px;

  /* _Light */

  color: #fbfbfb;
}
.part7Line {
  width: 120px;
  height: 1px;
  /* margin-bottom:99px; */
  margin-top: 108px;

  background: #b4c0cf;
}
.part5 {
  display: grid;
  grid-template-columns: 170px 2fr 0.5fr 2fr 0.5fr 2fr 0.2fr;
  grid-auto-rows: minmax(472, auto);
  background: #e5e5e5;
}
.part5-0 {
  grid-column: 2/7;
  grid-row: 1/2;
}
.part5-1 {
  grid-column: 1/2;
  grid-row: 3/3;
}

.part5-2 {
  grid-column: 2/7;
  grid-row: 2/2;
}

.part5-3 {
  grid-column: 2/3;
  grid-row: 3/3;
}

.part5-4 {
  grid-column: 4/5;
  grid-row: 3/3;
}
.part5-5 {
  grid-column: 6/7;
  grid-row: 3/3;
}
.part4 {
  display: grid;
  grid-template-columns: 200px 2fr 2fr 0.7fr 1fr 1fr 0.5fr 0.5fr;
  grid-auto-rows: minmax(472, auto);
  background: #272d31;
}
.part4-1 {
  grid-column: 1/2;
  grid-row: 2/2;
}
.part4-2 {
  grid-column: 2/4;
  grid-row: 1/2;
}

.part4-3 {
  grid-column: 5/7;
  grid-row: 1/2;
}
.part4-4 {
  grid-column: 7/8;
  grid-row: 1/2;
}

.part4-5 {
  grid-column: 8/9;
  grid-row: 1/2;
}
.part4-6 {
  grid-column: 2/9;
  grid-row: 2/3;
}
.part3 {
  display: grid;
  grid-template-columns: 0.5fr 2fr 0.3fr 2fr 0.5fr;
  grid-auto-rows: minmax(254px, auto);
}
.part3-0 {
  grid-column: 2/3;
  grid-row: 1/2;
  display: flex;
}
.part3-1 {
  grid-column: 1/2;
  grid-row: 2/2;
}
.part3-2 {
  grid-column: 2/3;
  grid-row: 2/2;
}
.part3-5 {
  grid-column: 4/5;
  grid-row: 2/2;
}
.part2aboutline {
  width: 196px;
  height: 24px;

  margin-top: 96px;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 24px;
  /* identical to box height, or 200% */

  letter-spacing: 2px;

  /* metalix (ligtt,text) */

  color: #36454f;
}
.part2line {
  width: 120px;
  height: 1.5px;
  margin-top: 108px;
  background: #b4c0cf;
}
.part2line-1 {
  margin-bottom: 5.5rem;
  width: 120px;
  height: 1.5px;
  margin-top: 108px;
  background: #b4c0cf;
}
.part2 {
  display: grid;
  grid-template-columns: 0.5fr 2fr 0.3fr 2fr 0.5fr;
  grid-auto-rows: minmax(108px, auto);
}
.part2-0 {
  grid-column: 2/3;
  grid-row: 1/2;
  display: flex;
}

.part2item-1 {
  grid-column: 2/3;
  grid-row: 2/2;
}

.part2item-2 {
  grid-column: 4/5;
  grid-row: 2/2;
}
.part2Title {
  width: 100%;
  height: 256px;
  text-align: left;
  /* margin-left: 232px; */
  margin-top: 88px;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 56px;
  line-height: 64px;
  /* or 114% */

  letter-spacing: 0.05em;

  /* metalix (ligtt,text) */

  color: #36454f;
}
.part2Title2 {
  width: 100%;
  height: 200px;
  text-align: left;
  margin-top: 88px;
  /* margin-right: 80px; */
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 40px;
  /* or 222% */

  letter-spacing: 0.1em;
  text-indent: 32px;

  /* metalix (ligtt,text) */

  color: #36454f;
}
.button-project{
  position: absolute;
width: 392px;
height: 64px;
left: 1044px;
top: 2304px;

background-color: white;
border-style: none !important;
border: 1px solid #233B57 !important;
box-sizing: border-box;
}

.carouselImg {
  position: relative;
  top: 0;
  left: 0;
  /* background: radial-gradient(83.12% 398.5% at 79.31% 100%, rgba(35, 59, 87, 0) 0%, #233B57 100%);
mix-blend-mode: normal;
opacity: 0.48;*/
}
.paginationLeft {
  margin-top: 49px;
  margin-left: 32px;
  margin-bottom: 39px;
}
.paginationRight {
  margin-top: 49px;
  margin-right: 32px;
  margin-bottom: 39px;
}
.bigCarousel {
  /* position: relative;
  width: 100%;
  height: 100%; */
}
.carouselPagination {
  position: absolute;
  width: 456px;
  height: 120px;
  background: #fbfbfb;
  bottom: 5px;
  left: 0;
}
.mainTitle {
  text-align: left;
  position: absolute;
  font-family: Inter;
  font-style: normal;
  font-weight: bold;
  font-size: 64px;
  line-height: 88px;
  /* or 137% */
  z-index: 5;

  margin-top: -500px;
  margin-left: 152px;

  letter-spacing: 0.015em;
  text-transform: uppercase;

  /* _Text */

  color: #fbfbfb;
}
.part8mainTitle {
  text-align: left;
  position: fixed;
  font-family: Inter;
  font-style: normal;
  font-weight: bold;
  font-size: 36px;
  line-height: 58px;
  /* or 137% */
  z-index: 5;
  margin-top: 0px;
  margin-left: 0px;

  letter-spacing: 0.015em;
  text-transform: uppercase;

  /* _Text */

  color: #fbfbfb;
}
.rectangInfo {
  position: absolute;
  width: 248px;
  height: 24px;
  left: 0px;
  margin-top: 416px;
  margin-left: -30px;

  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  /* identical to box height, or 200% */

  letter-spacing: 0.25em;

  /* metalix (ligtt,text) */

  color: #36454f;

  transform: rotate(-90deg);
}
.rectang {
  position: absolute;
  width: 336px;
  height: 2px;
  margin-top: 168px;
  margin-left: -150px;
  /* metalix (ligtt,text) */

  background: #36454f;
  /* line */

  box-shadow: inset 1px 0px 0px #36454f;
  transform: rotate(-90deg);
}
.part1 {
  display: grid;
  grid-template-columns: 200px 1fr 1fr;
  grid-auto-rows: minmax(680px, auto);
  background-color: #ffffff;
}
.part1-0 {
  grid-column: 1/2;
  grid-row: 1/2;
}
.part1-1 {
  grid-column: 2/4;
  grid-row: 1/2;
}
.part13AdresInfoimg {
  margin-top: 45px;
  /* width: 40px;
  height: 40px; */
}

/***************Other */
.infoBlockTitle h3 {
  max-width: 100%;
  min-height: 2rem;
}
.infoBlockIcon {
  /* width: 52px;
    height: 48px;
    margin-left: 16px; */
  /* margin-top: -70px; */
  text-align: left;
}
.infoBlock h3 {
  text-align: left;
  /* margin-left: 45px; */
}
.infoBlockP {
  margin-left: 0px;
}
/*******************************Media Quiery **************/

/* Smartphones (landscape) ----------- /
@media only screen and (min-width: 321px) {
  /* Styles /
}

/* Smartphones (portrait) ----------- *
@media only screen and (max-width: 320px) {
  /* Styles *
}

/* iPads (portrait and landscape) ----------- *
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  /* Styles *
}

/* iPads (landscape) ----------- *
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
  /* Styles *
}

/* iPads (portrait) ----------- *
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  /* Styles *
}

/* Desktops and laptops ----------- *
@media only screen and (min-width: 1224px) {
  /* Styles /
  .part13T {
    font-size: 22px;
  }
  .part13Tp {
    width: 520px;
    font-size: 14px;
  }
  .part5MiniBlockT {
    height: 80px;

    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 40px;
    /* or 167% /
    text-align: left;
    letter-spacing: 0.1em;
    margin: 16px 24px 48px 24px;
    /* metalix (ligtt,text) /

    color: #36454f;
  }
  .part5MiniBlockP {
    text-align: left;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 22px;
    /* or 229% /
    margin: 48px 10px 48px 4px;
    letter-spacing: 0.1em;
    text-indent: 24px;
    /* metalix (ligtt,text) /

    color: #36454f;
  }
  .part5 {
    display: grid;
    grid-template-columns: 200px 1fr 1fr 1fr;
    grid-auto-rows: minmax(472, auto);
    background: #f2f6f5;
  }
  .part5-0 {
    grid-column: 2/4;
    grid-row: 1/2;
  }
  .part5-1 {
    grid-column: 1/2;
    grid-row: 3/3;
  }

  .part5-2 {
    grid-column: 2/5;
    grid-row: 2/2;
  }

  .part5-3 {
    grid-column: 2/3;
    grid-row: 3/3;
  }

  .part5-4 {
    grid-column: 3/4;
    grid-row: 3/3;
  }
  .part5-5 {
    grid-column: 4/4;
    grid-row: 3/3;
  }
  .part5leftLine {
    width: 164px;
    height: 1px;
    margin-top: 180px;
    margin-left: -31px;
    background: #272a2e;
    /* line /

    box-shadow: inset 1px 0px 0px #36454f;
    transform: rotate(-90deg);
  }*
}
/* ----------- Non-Retina Screens ----------- */
/* @media screen and (min-device-width: 1441px) and (max-device-width: 1600px) and (-webkit-min-device-pixel-ratio: 1) { */
/**** 1030px*/
@media only screen and (min-width: 1281px) and (max-width: 1366px) {
  .part11BlockLine2{
    width: 205px;
  }
  .part11Title{
    font-size: 26px;
  }
 #fname {
    /* margin-top: 40px; */
    width: 250px !important;
  }
  .coverImgCarousel2 {
    display: flex;
    vertical-align: center;
    align-items: center;
  }
  .productListIconImage {
    margin: 0px;
  }
  .productListh2 {
    margin: 0px;
  }
  .rectang {
    position: absolute;
    width: 336px;
    height: 2px;
    margin-left: -140px;
    /* metalix (ligtt,text) */
    margin-top: 167px;
    background: #36454f;
    /* line */

    box-shadow: inset 1px 0px 0px #36454f;
    transform: rotate(-90deg);
  }
  .part2Title {
    font-size: 36px;
  }
  .mainTitle {
    max-width: 70%;
    font-size: 35px;
  }
  .part8mainTitle {
    max-width: 80%;
    font-size: 36px;
    margin-top: -600px;
  }
  .rectangInfo {
    position: absolute;
    width: 248px;
    height: 24px;

    margin-left: -55px !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 24px;
    /* identical to box height, or 200% */

    letter-spacing: 0.25em;

    /* metalix (ligtt,text) */

    color: #36454f;

    transform: rotate(-90deg);
  }
  #first .VueCarousel-navigation-next {
    z-index: 4 !important;
    margin-right: 855px !important;
    margin-top: 280px !important;
  }
  #first .VueCarousel-navigation-prev {
    margin-top: 280px !important;
    margin-left: 50px !important;
    z-index: 4 !important;
  }
  .part5MiniBlockT {
    height: 80px;

    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 40px;
    /* or 167% */
    text-align: left;
    letter-spacing: 0.1em;
    margin: 16px 24px 48px 24px;
    /* metalix (ligtt,text) */

    color: #36454f;
  }
  .part5MiniBlockP {
    text-align: left;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 22px;
    /* or 229% */
    margin: 48px 10px 48px 4px;
    letter-spacing: 0.1em;
    text-indent: 24px;

    /* metalix (ligtt,text) */

    color: #36454f;
  }
  .part5 {
    display: grid;
    grid-template-columns: 100px 1fr 1fr 1fr;
    grid-auto-rows: minmax(472, auto);
    background: #f2f6f5;
  }
  .part5-0 {
    grid-column: 2/4;
    grid-row: 1/2;
  }
  .part5-1 {
    grid-column: 1/2;
    grid-row: 3/3;
  }
  .part5MiniBlockP {
    width: 250px;
  }
  .part5MiniBlockT {
    width: 200px;
  }

  .part5-2 {
    grid-column: 2/5;
    grid-row: 2/2;
  }

  .part5-3 {
    grid-column: 2/3;
    grid-row: 3/3;
  }

  .part5-4 {
    grid-column: 3/4;
    grid-row: 3/3;
  }
  .part5-5 {
    grid-column: 4/4;
    grid-row: 3/3;
  }
  .part5leftLine {
    width: 164px;
    height: 1px;
    margin-top: 180px;
    margin-left: -31px;
    background: #272a2e;
    /* line */

    box-shadow: inset 1px 0px 0px #36454f;
    transform: rotate(-90deg);
  }

  .part6P {
    margin-left: 168px;
  }
  /*****part7 */
  .part7 {
    display: grid;
    grid-template-columns: 20px 2fr 0.5fr 2fr 0.5fr 2fr 0.2fr;
    grid-auto-rows: minmax(472, auto);
    background: #272d31;
  }
  .part7-0 {
    grid-column: 2/4;
    grid-row: 1/2;
  }
  .part7-1 {
    display: none;
  }

  .part7-2 {
    grid-column: 2/4;
    grid-row: 2/2;
  }

  .part7-3 {
    grid-column: 4/7;
    grid-row: 2/2;
  }

  .part7-4 {
    grid-column: 2/4;
    grid-row: 3/3;
  }
  .part7-5 {
    grid-column: 4/7;
    grid-row: 3/3;
  }
  .part7-6 {
    grid-column: 2/5;
    grid-row: 4/4;
    margin-bottom: 72px;
  }
  .part7-7 {
    grid-column: 5/7;
    grid-row: 4/4;
  }
  .part7Button {
    margin-top: 60px;
    width: 400px;
  }
  .part7BI {
    position: absolute;
    margin-left: 85px;
    margin-right: 0;
    color: #fbfbfb;
  }
  /*****part11 */
  .part11 {
    display: grid;
    grid-template-columns: 20px 1fr 1fr 1fr 1fr 1fr 0.5fr;
    grid-auto-rows: minmax(1136, auto);
    background: #fafafa;
    margin-top: 235px;
  }
  .part11-1 {
    display: none;
  }
  /****part12 */
  .part12 {
    display: grid;
    grid-template-columns: 16px 1fr 1fr 1fr 16px;
    grid-auto-rows: minmax(1136, auto);
    background: #36454f;
  }
  .part12-2 {
    display: none;
  }
  .part12-0 {
    grid-column: 2/4;
    grid-row: 1/2;
  }
  .part12-1 {
    grid-column: 3/3;
    grid-row: 1/2;
  }

  .part12-3 {
    grid-column: 2/3;
    grid-row: 2/3;
  }
  .part12-4 {
    grid-column: 3/4;
    grid-row: 2/5;
  }
  .part12-5 {
    grid-column: 2/4;
    grid-row: 3/4;
  }
  .part12-6 {
    grid-column: 2/4;
    grid-row: 4/5;
  }
  .inputMar {
    margin-left: 76px;
  }
  .part12-1Line {
    width: 700px;
  }
  #fname {
    width: 302px;
  }

  /******part6 */
  .part6 {
    display: grid;
    grid-template-columns: 16px 2fr 0.5fr 2fr 0.5fr 2fr 0.2fr;
    grid-auto-rows: minmax(472, auto);
    background: #fbfbfb;
  }
  .part6-1 {
    display: none;
  }
  /*****part13 */
  /************part13 */
  .part13 {
    display: grid;
    grid-template-columns: 16px 1fr 1fr 1fr 1fr 1fr 0.5fr;
    grid-auto-rows: minmax(1136, auto);
    background: #fbfbfb;
  }

  .part13-0 {
    display: none;
  }
  .part13AdresInfoimg {
    margin-top: 45px;
    width: 40px;
    height: 40px;
  }
  .part13Tp {
    width: 350px;
    font-size: 12px;
  }

  .phoneInfo {
    margin-left: 0px;
  }
  .part7Button {
    margin-left: 300px;
  }
  .mainTitle {
    margin-top: -420px;
    margin-left: 92px;
  }
  .part7P {
    font-size: 14px;
  }
  /**************part12 */
  .part12 {
    display: grid;
    grid-template-columns: 50px 1fr 1fr 1fr 1fr 1fr;
    grid-auto-rows: minmax(1136, auto);
    background: #36454f;
  }

  .part12-2 {
    display: none;
  }
  .part6 {
    display: grid;
    grid-template-columns: 50px 2fr 0.5fr 2fr 0.5fr 2fr 0.2fr;
    grid-auto-rows: minmax(472, auto);
    background: #fbfbfb;
  }

  .part6-1 {
    display: none;
  }
  .part6P {
    max-width: 596px;
  }

  .part13-0T {
    margin-top: 135px;
  }
  .rectangInfo {
    margin-left: -41px !important;
  }
  .part5 {
    display: grid;
    grid-template-columns: 50px 1fr 1fr 1fr;
    grid-auto-rows: minmax(472, auto);
    background: #f2f6f5;
  }
  .part5-1 {
    display: none;
  }
  .part13Tp {
    width: 328px;
    font-size: 12px;
  }
  .part5line1 {
    margin-left: 110px;
  }
  .part12InfoButton {
    max-width: 250px !important;
  }
  .part12InfoLine {
    max-width: 700px;
  }
  .part12Infotextarea {
    width: 600px !important;
    margin-left: 50px !important;
  }
  /* .productListIconImage{
position:absolute;
width:144px; 
height:144px; 
margin-top:-46vh; 
margin-left:8rem; 
z-index:26; 
box-shadow:0px 2px 3px black; 
}
.productListh2{
position:absolute;
margin-top:-20vh;
margin-left:30px;
font-weight:bold; 
color:white;
 z-index:26; 
 text-shadow:1px 1px 1px black;
} */
  /* .infoBlock{
border: 2px solid green;
} */

  /* .infoBlock img{
    margin-top: -120px;
  } */
}

/* ----------- Retina Screens ----------- *
@media screen and (min-device-width: 1200px) and (max-device-width: 1600px) and (-webkit-min-device-pixel-ratio: 2) and (min-resolution: 192dpi) {
  .phoneInfo {
    margin-left: 0px;
  }
  .part7P {
    font-size: 14px;
  }
  /**************part12 **
  .part12 {
    display: grid;
    grid-template-columns: 16px 1fr 1fr 1fr 1fr 1fr;
    grid-auto-rows: minmax(1136, auto);
    background: #36454f;
  }

  .part12-2 {
    display: none;
  }

  .part12Infotextarea {
    margin-left: 85px;
  }
  .part13-0T {
    margin-top: 35px;
  }
  .part6 {
    display: grid;
    grid-template-columns: 50px 2fr 0.5fr 2fr 0.5fr 2fr 0.2fr;
    grid-auto-rows: minmax(472, auto);
    background: #fbfbfb;
  }

  .part6-1 {
    display: none;
  }
  .part6P {
    max-width: 596px;
  }
  .part5 {
    display: grid;
    grid-template-columns: 20px 1fr 1fr 1fr;
    grid-auto-rows: minmax(472, auto);
    background: #f2f6f5;
  }
  .part5-1 {
    display: none;
  }
}
/* min width 1281px */
@media (min-width: 1367px) and (max-width: 1440px) {
  .rectang {
    position: absolute;
    width: 336px;
    height: 2px;
    margin-left: -158px;
    /* metalix (ligtt,text) */
    margin-top: 167px;
    background: #36454f;
    /* line */

    box-shadow: inset 1px 0px 0px #36454f;
    transform: rotate(-90deg);
  }
  .mpart1 {
   
    grid-template-columns: 220px 1fr 384px;






}
 .sending-btn{
    width: 365px;
  }
  .project_footer{
    display: flex;
    justify-content: space-evenly;
  }
  .email-footer{
    margin-left: .6rem;
    margin-top: 0px;
  }
  .mainTitle {
    max-width: 60%;
  }
  .part12InfoLine{
    width: 700px;
    margin-left: 75px;
  }
  .part12InfoButton{
    width: 300px;
    margin-left: 15px;
  }
  .part12Margin{
    margin-left: 60px;
  }
  .part8mainTitle {
    max-width: 60%;
  }
  .rectangInfo {
    position: absolute;
    width: 248px;
    height: 24px;

    margin-left: -55px !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 24px;
    /* identical to box height, or 200% */

    letter-spacing: 0.25em;

    /* metalix (ligtt,text) */

    color: #36454f;

    transform: rotate(-90deg);
  }
  .mpart1Title{
    margin-left: -20px;
    font-size: 44px;
  }
  .fishes{
    width: 565px;
  }
  .fish{
    width: 120px;
    height: 120px;
  }
  .mainTitle{
    font-size: 44px;
  }
  #first .VueCarousel-navigation-next {
    z-index: 4 !important;
    margin-right: 855px !important;
    margin-top: 280px !important;
  }
  #first .VueCarousel-navigation-prev {
    margin-top: 280px !important;
    margin-left: 50px !important;
    z-index: 4 !important;
  }
  .part5MiniBlockT {
    height: 80px;

    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 40px;
    /* or 167% */
    text-align: left;
    letter-spacing: 0.1em;
    margin: 16px 24px 48px 24px;
    /* metalix (ligtt,text) */

    color: #36454f;
  }
  .part5MiniBlockP {
    text-align: left;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 22px;
    /* or 229% */
    margin: 48px 10px 48px 4px;
    letter-spacing: 0.1em;
    text-indent: 24px;

    /* metalix (ligtt,text) */

    color: #36454f;
  }
  .part5 {
    display: grid;
    grid-template-columns: 100px 1fr 1fr 1fr;
    grid-auto-rows: minmax(472, auto);
    background: #f2f6f5;
  }
  .part5-0 {
    grid-column: 2/4;
    grid-row: 1/2;
  }
  .part5-1 {
    grid-column: 1/2;
    grid-row: 3/3;
  }
  .part5MiniBlockP {
    width: 250px;
  }
  .part5MiniBlockT {
    width: 200px;
  }
  .part12Infotextarea {
    width: 44em !important;
    margin-left: 60px !important;
  }

  .part5-2 {
    grid-column: 2/5;
    grid-row: 2/2;
  }

  .part5-3 {
    grid-column: 2/3;
    grid-row: 3/3;
  }

  .part5-4 {
    grid-column: 3/4;
    grid-row: 3/3;
  }
  .part5-5 {
    grid-column: 4/4;
    grid-row: 3/3;
  }
  .part5leftLine {
    width: 164px;
    height: 1px;
    margin-top: 180px;
    margin-left: -31px;
    background: #272a2e;
    /* line */

    box-shadow: inset 1px 0px 0px #36454f;
    transform: rotate(-90deg);
  }

  .part6P {
    margin-left: 168px;
  }
  /*****part7 */
  .part7 {
    display: grid;
    grid-template-columns: 20px 2fr 0.5fr 2fr 0.5fr 2fr 0.2fr;
    grid-auto-rows: minmax(472, auto);
    background: #272d31;
  }
  .part7-0 {
    grid-column: 2/4;
    grid-row: 1/2;
  }
  .part7-1 {
    display: none;
  }

  .part7-2 {
    grid-column: 2/4;
    grid-row: 2/2;
  }

  .part7-3 {
    grid-column: 4/7;
    grid-row: 2/2;
  }

  .part7-4 {
    grid-column: 2/4;
    grid-row: 3/3;
  }
  .part7-5 {
    grid-column: 4/7;
    grid-row: 3/3;
  }
  .part7-6 {
    grid-column: 2/5;
    grid-row: 4/4;
    margin-bottom: 72px;
  }
  .part7-7 {
    grid-column: 5/7;
    grid-row: 4/4;
  }
  .part7Button {
    margin-top: 60px;
    width: 400px;
  }
  .part7BI {
    position: absolute;
    margin-left: 85px;
    margin-right: 0;
    color: #fbfbfb;
  }
  /*****part11 */
  .part11 {
    display: grid;
    grid-template-columns: 20px 1fr 1fr 1fr 1fr 1fr 0.5fr;
    grid-auto-rows: minmax(1136, auto);
    background: #fafafa;
    margin-top: 235px;
  }
  .part11-1 {
    display: none;
  }
  /****part12 */
  .part12 {
    display: grid;
    grid-template-columns: 40px 1fr 1fr 1fr 16px;
    grid-auto-rows: minmax(1136, auto);
    background: #36454f;
  }
  .part12-2 {
    display: none;
  }
  .part12-0 {
    grid-column: 2/4;
    grid-row: 1/2;
  }
  .part12-1 {
    grid-column: 3/3;
    grid-row: 1/2;
  }
  .part12-3T{
    font-size: 30px;
  }
  .part12-3 {
    grid-column: 2/3;
    grid-row: 2/3;
  }
  .part12-4 {
    grid-column: 3/4;
    grid-row: 2/5;
  }
  .part12-5 {
    grid-column: 2/4;
    grid-row: 3/4;
  }
  .part12-6 {
    grid-column: 2/4;
    grid-row: 4/5;
  }
  .inputMar {
    margin-left: 76px;
  }
  .part12Infotextarea {
    margin-left: 0px;
  }
  .part12-1Line {
    width: 700px;
    margin-left: 60px;
  }
  #fname {
    width: 302px;
  }
  .part12Infotextarea {
    width: 720px;
  }

  /******part6 */
  .part6 {
    display: grid;
    grid-template-columns: 16px 2fr 0.5fr 2fr 0.5fr 2fr 0.2fr;
    grid-auto-rows: minmax(472, auto);
    background: #fbfbfb;
  }
  .part6-1 {
    display: none;
  }
  /*****part13 */
  /************part13 */
  .part13 {
    display: grid;
    grid-template-columns:40px 1fr 1fr 1fr 1fr 1fr 0.5fr;
    grid-auto-rows: minmax(1136, auto);
    background: #fbfbfb;
  }
  .part13-0 {
    display: none;
  }
  .part13AdresInfoimg {
    margin-top: 45px;
    width: 40px;
    height: 40px;
  }
  .part13Tp {
    width: 350px;
    font-size: 12px;
  }
}
/* Desktops and laptops  1280-----------@media only screen and (max-width: 1280px) { old */
@media (min-width: 1025px) and (max-width: 1280px) {
  /* Styles */
  /******* */
  .part13T {
    font-size: 22px;
  }
  .part13Tp {
    width: 520px;
    font-size: 14px;
  }
  .part5MiniBlockT {
    height: 80px;

    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 40px;
    /* or 167% */
    text-align: left;
    letter-spacing: 0.1em;
    margin: 16px 24px 48px 24px;
    /* metalix (ligtt,text) */

    color: #36454f;
  }
  .part5MiniBlockP {
    text-align: left;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 22px;
    /* or 229% */
    margin: 48px 10px 48px 4px;
    letter-spacing: 0.1em;
    text-indent: 24px;

    /* metalix (ligtt,text) */

    color: #36454f;
  }
  .part5 {
    display: grid;
    grid-template-columns: 200px 1fr 1fr 1fr;
    grid-auto-rows: minmax(472, auto);
    background: #f2f6f5;
  }
  .part5-0 {
    grid-column: 2/4;
    grid-row: 1/2;
  }
  .part5-1 {
    grid-column: 1/2;
    grid-row: 3/3;
  }

  .part5-2 {
    grid-column: 2/5;
    grid-row: 2/2;
  }

  .part5-3 {
    grid-column: 2/3;
    grid-row: 3/3;
  }

  .part5-4 {
    grid-column: 3/4;
    grid-row: 3/3;
  }
  .part5-5 {
    grid-column: 4/4;
    grid-row: 3/3;
  }
  .part5leftLine {
    width: 164px;
    height: 1px;
    margin-top: 180px;
    margin-left: -31px;
    background: #272a2e;
    /* line */

    box-shadow: inset 1px 0px 0px #36454f;
    transform: rotate(-90deg);
  }
  /****** */
  .part8Title {
    margin-left: 100px !important;
  }
  .sec4Img {
    width: 100%;
  }
  .mainTitle {
    max-width: 50%;
    margin-top: -401px;
    font-size: 32px;
  }
  .part8mainTitle {
    max-width: 50%;
    margin-top: -401px;
    font-size: 32px;
  }
  .part1Colum {
    display: none;
  }
  .part1Margin {
    margin-left: 45px;
  }

  .part4about {
    margin-left: -135px;
  }
  .part4rec {
    margin-left: -32px;
  }
  .part5Title {
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 48px;
    margin-top: 99px;
    margin-left: 0;
    /* margin-right: 80px; */
    margin-bottom: 96px;
    /* or 150% */
    text-align: left;
    letter-spacing: 0.1em;
    text-indent: 32px;

    /* metalix (ligtt,text) */

    color: #36454f;
  }
  .part5MiniBlockT {
    height: 80px;

    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 40px;
    /* or 167% */
    text-align: left;
    letter-spacing: 0.1em;
    margin: 16px 0px 48px 0px;
    /* metalix (ligtt,text) */

    color: #36454f;
  }
  .part5MiniBlockP {
    text-align: left;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 22px;
    /* or 229% */
    margin: 48px 0px 48px 0px;
    letter-spacing: 0.1em;
    text-indent: 24px;

    /* metalix (ligtt,text) */

    color: #36454f;
  }
  .part5 {
    display: grid;
    grid-template-columns: 100px 1fr 1fr 1fr;
    grid-auto-rows: minmax(472, auto);
    background: #f2f6f5;
  }
  .part5-0 {
    grid-column: 2/4;
    grid-row: 1/2;
  }
  .part5-1 {
    grid-column: 1/2;
    grid-row: 3/3;
  }

  .part5-2 {
    grid-column: 2/5;
    grid-row: 2/2;
  }

  .part5-3 {
    grid-column: 2/3;
    grid-row: 3/3;
  }

  .part5-4 {
    grid-column: 3/4;
    grid-row: 3/3;
  }
  .part5-5 {
    grid-column: 4/4;
    grid-row: 3/3;
  }
  .part5leftLine {
    width: 164px;
    height: 1px;
    margin-top: 180px;
    margin-left: -31px;
    background: #272a2e;
    /* line */

    box-shadow: inset 1px 0px 0px #36454f;
    transform: rotate(-90deg);
  }
  .part6Title {
    font-size: 24px;
  }
  .part6P {
    font-size: 14px;
    margin-left: 68px;
  }
  .part6BlockTitle {
    width: 255px;
    font-size: 18px;
  }
  .part6BlockP {
    width: 260px;
    font-size: 10px;
  }
  .part7Title {
    width: 496px;
    height: 112px;
    text-align: left;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 26px;
    line-height: 56px;
    /* or 140% */
    margin: 88px 0px;
    letter-spacing: 0.1em;

    /* _Light */

    color: #fbfbfb;
  }

  .part7P2 {
    width: 396px;
    font-weight: 500;
    font-size: 12px;
    line-height: 40px;
  }
  .part7P {
    /* width: 696px; */
    margin-left: 86px;
    height: 120px;
    text-align: left;

    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 40px;
    /* or 222% */
    margin-top: 88px;
    margin-bottom: 88px;
    letter-spacing: 0.1em;
    text-indent: 32px;

    /* _Light */

    color: #fbfbfb;
  }
  .part7Button {
    width: 300px;
    margin-left: 20px;
    height: 65px;
    color: #fbfbfb;
    background: transparent;
    border: 1px solid #fbfbfb;
    box-sizing: border-box;
  }
  .part7BI {
    position: absolute;
    margin-left: 50px;
    margin-right: 0;
    margin-top: -3px;
    color: #fbfbfb;
  }
  .part8 {
    display: grid;
    grid-template-columns: 50px 2fr 0.5fr 0.5fr 0.5fr;
    grid-auto-rows: minmax(472, auto);
    background: #ffffff;
  }
  .part8-1 {
    display: none;
  }
  .part8Title {
    margin-left: 2px;
    margin-right: 2px;

    font-weight: 600;
    font-size: 18px;
  }
  .part11 {
    display: grid;
    grid-template-columns: 110px 1fr 1fr 1fr 1fr 1fr 0.5fr;
    grid-auto-rows: minmax(1136, auto);
    background: #fafafa;
    margin-top: 235px;
  }

  .part11Title {
    width: 350px;
  }
  #th .VueCarousel-navigation-next {
    z-index: 4 !important;
    margin-right: 90px !important;
    margin-top: -422px !important;
  }
  #th .VueCarousel-navigation-prev {
    margin-top: -422px !important;
    margin-left: 975px !important;
    z-index: 4 !important;
  }
  .part11Title {
    height: 66px;
    text-align: left;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
  }
  .part11B {
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 20px;
    /* identical to box height, or 200% */

    text-align: center;
    letter-spacing: 2px;
    text-transform: uppercase;
    width: 344px;
    color: #233b57;
    height: 64px;
    background: transparent;
    border: 1px solid #233b57;
    box-sizing: border-box;
  }
  .part11BTitle {
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 32px;
    /* or 160% */
    height: 128px;
    letter-spacing: 0.1em;
    text-align: left;
    /* _Text */
    margin-top: 92px;
    margin-bottom: 32px;
    color: #233b57;
  }
  .part11BTitle2 {
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 32px;
    /* or 160% */
    height: 128px;
    letter-spacing: 0.1em;
    text-align: left;
    /* _Text */
    /* margin-left: 43px; */
    margin-top: 32px;
    margin-bottom: 88px;
    color: #233b57;
  }
  .part11Imargin {
    /* width: 170px;
  height: 50; */
  }
  .part11-8 {
    display: none;
  }
  .part11-7 {
    display: none;
  }
  .part11-3 {
    grid-column: 4/5;
  }
  .part12 {
    display: grid;
    grid-template-columns: 50px 1fr 1fr 1fr 1fr 1fr;
    grid-auto-rows: minmax(1136, auto);
    background: #36454f;
  }
  .part12-2 {
    display: none;
  }
  .part12-3T {
    width: 303px;
    height: 144px;
    margin-top: 0;
    text-align: left;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
  }
  #fname {
    width: 300px;
    height: 64px;

    /* _Light */

    background: #fbfbfb;
    /* _Light */

    border: 1px solid #fbfbfb;
    box-sizing: border-box;
  }

  .part12Infotextarea {
    width: 712px;
    margin-left: -12px;
  }
  .part12TitleLine {
    display: none;
  }
  .part12Tp {
    width: 242px;
    height: 96px;
    text-align: left;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 11px;
    line-height: 32px;
    /* or 200% */
    margin-top: 60px;
    letter-spacing: 0.1em;

    /* _Light */

    color: #fbfbfb;
  }
  .part12Tp2 {
    width: 292px;
    height: 96px;
    text-align: left;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 32px;
    /* or 200% */
    margin-top: 7px;
    /* margin-bottom: 104px; */
    letter-spacing: 0.1em;

    /* _Light */

    color: #fbfbfb;
  }
  .part12InfoMust {
    width: 492px;
    height: 24px;
    text-align: left;
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    margin-left: 105px;
  }
  .part12InfoLine {
    width: 690px;
    height: 1px;
    margin-bottom: 63px;
    /* _Light */
    margin-left: 120px;
    background: #fbfbfb;
    opacity: 0.16;
  }
  .part12Checkp {
    font-size: 12px;
  }
  .part12InfoButton {
    width: 292px;
    height: 40px;
  }
  .part13T {
    font-size: 22px;
  }
  .part13 {
    display: grid;
    grid-template-columns: 50px 1fr 1fr 1fr 1fr 1fr 0.5fr;
    grid-auto-rows: minmax(1136, auto);
    background: #fbfbfb;
  }
  .part13-0 {
    display: none;
  }
  .part13Tp {
    width: 520px;
    font-size: 14px;
  }
  .part13T {
    font-size: 16px;
  }
  .part6 {
    display: grid;
    grid-template-columns: 50px 2fr 0.5fr 2fr 0.5fr 2fr 0.2fr;
    grid-auto-rows: minmax(472, auto);
    background: #fbfbfb;
  }
  .part6-1 {
    display: none;
  }
  .part7 {
    /* display: grid ;
    grid-gap: 1rem !important;
    grid-template-columns: repeat(auto-fit, minmax(20ch, 1fr)) !important; */
    display: grid;
    grid-template-columns: 50px 2fr 0.5fr 2fr 0.5fr 2fr 0.2fr;
    grid-auto-rows: minmax(472, auto);
    background: #272d31;
  }

  .part7-1 {
    display: none;
  }
  .part4 {
    display: grid;
    grid-template-columns: 50px 2fr 2fr 0.7fr 1fr 1fr 0.5fr 0.5fr;
    grid-auto-rows: minmax(472, auto);
    background: #272d31;
  }
  .part4-1 {
    display: none;
  }
  .part12Margin {
    margin-left: 95px;
  }
}
/****1440 */

/* Large screens ----------- /
@media only screen and (min-width: 1824px) {
  /* Styles /
}

/* iPhone 4 ----------- /
@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
  only screen and (min-device-pixel-ratio: 1.5) {
  /* Styles /
}

/* Smartphones (portrait and landscape) ----------- */
@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
  /* Styles */
   .sending-btn{
    width: 340px !important;
    margin-left: 28px !important;
}
.form-metalix-1{
  width: 340px !important;
  margin-left: 17px;
}
.checking{
  display: none;
}
  .mpart1p{
    width: 100% !important;
  }
  .mpart1 {
    display: block;
    grid-template-columns: 30px 1fr 384px;
    grid-auto-rows: minmax(472, auto);
    background: #fbfbfb;
}
.mpart1-1Title {
    display: flex;
    justify-content: left;
    margin-top:0px;
}
.mpart1pp{
  margin-bottom: 0;
}
.fishes{
  width: 100%;
}
.mpart1Title{
  font-size: 30px;
  line-height: 40px;
  margin-top: 3rem;
  margin-left: 0;
}
.mpart1-1 .mpart1p{
  margin-left: 2rem;
  font-size: 20px;
  width: 90% !important;
}
  .mpart1pp{
    margin-top: 21rem;
    margin-left: -1rem;
    width: 100%;
  }
  .three-btn-callback{
    margin-top: 0rem !important;
  }
  .part2item-2 .middle-section-pr{
    margin-top: -2rem !important;
  }
  .part1Margin{
    margin-left: 0;
  }
  .part2line-1{
    display: none;
  }
  .carouselMain{
    display: block;
  }
  .home-icon{
    width: 35%;
    margin-left: 5rem;
    margin-bottom: 3rem;
  }
  .whiteBox{
    display: none;
  }
  .inputMar {
    margin-left: 0px;
  }
  #fname {
    margin-top: 40px;
    width: 300px !important;
    margin-left: 2px !important;
  }
  .row > * {
    flex-shrink: 0;
    width: 100%;
    padding-right: 0;
    padding-left: 0;
    margin-top: 0;
  }
  .container,
  .container-fluid,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl,
  .container-xxl {
    width: 100%;
    padding-right: 0;
    padding-left: 0;
    margin-right: 0;
    margin-left: 0;
  }
  .row {
    --bs-gutter-x: 0rem;
  }
  .swiper-pagination {
    display: none;
  }
  .swiper-button-next {
    display: none;
  }
  .swiper-button-prev {
    display: none;
  }
  .part1Colum {
    display: none;
  }
  .mainTitle {
    width: 328px;

    height: 160px;
    margin-left: 16px;
    font-family: Inter;
    font-style: normal;
    font-weight: bold;
    font-size: 32px;
    line-height: 40px;
    /* or 125% */
    z-index: 3;
    text-transform: uppercase;

    /* _Text */

    color: #fbfbfb;
  }
  .mainTitlep {
    position: absolute;
    width: 240px;
    height: 168px;
    left: 16px;
    
    z-index: 1;
    color: #fbfbfb !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
  }
  .part8mainTitle {
    width: 328px;

    height: 160px;
    margin-left: 16px;
    font-family: Inter;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 40px;
    /* or 125% */
    z-index: 3;
    text-transform: uppercase;

    /* _Text */

    color: #fbfbfb;
  }
  .part8mainTitlep {
    position: absolute;
    width: 240px;
    height: 168px;
    left: 40px;
    z-index: 1;
    color: #fbfbfb !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
  }
  .project-line{
    display: none;
  }
  .fish{
    width: 100px;
    height: 100px;
  }
  .part1 {
    display: grid;
    grid-template-columns: 1fr;
    grid-auto-rows: minmax(480px, auto);
  }

  .mainImgc {
    width: 100%;
    height: 480px;
  }
  .mobileHide {
    display: none;
  }
  .part4about {
    /* text-align: center; */
    width: 100%;
    height: 16px;
    left: 88px;
    top: 0px;

    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 16px;

    /* identical to box height, or 160% */
    letter-spacing: 2px;
    /* identical to box height, or 200% */
    margin-left: 16px;
    /* text-transform: uppercase; */

    /* line (darck) */

    color: #b4c0cf;

    transform: rotate(0deg);
  }
  .part4rec {
    width: 64px;
    height: 2px;
    background: #fcfdff;
    /* line */
    margin-top: -9px;
    margin-bottom: 80px;
    box-shadow: inset 1px 0px 0px #36454f;
    transform: rotate(0deg);
  }
  /******Part2 */
  .part2Title {
    /* position: absolute; */
    width: 328px;
    height: 96px;
    margin: 32px 16px;

    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;

    /* or 133% */
    letter-spacing: 0.05em;

    /* metalix (ligtt,text) */
    color: #36454f;
  }
  .part2Title2 {
    width: 240px;
    height: 240px;
    margin-left: 16px;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 24px;
    /* or 200% */
    margin-top: 0;
    letter-spacing: 0.15em;
    text-indent: 32px;

    /* metalix (ligtt,text) */

    color: #36454f;
  }
  .project-text{
    margin-top: 0 !important;
  }
  .part2 {
    display: grid;
    grid-template-columns: 1fr;
    grid-auto-rows: minmax(0px, auto);
  }
  .part2-0 {
    grid-column: 1/2;
    grid-row: 1/2;
    display: flex;
  }

  .part2item-1 {
    grid-column: 1/2;
    grid-row: 2/2;
  }

  .part2item-2 {
    grid-column: 1/2;
    grid-row: 3/3;
  }
  .part2line {
    width: 64px;
    height: 1px;
    margin-left: 16px;
    margin-top: 39px;

    background: #b4c0cf;
  }
  .part2aboutline {
    width: 153px;
    height: 16px;
    margin-left: 24px;
    margin-top: 32px;

    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 16px;

    /* identical to box height, or 160% */
    letter-spacing: 2px;

    /* metalix (ligtt,text) */
    color: #B4C0CF;
  }
  /*****part3 */
  .part3 {
    display: grid;
    /* grid-gap: 1rem !important; */
    /* grid-template-columns: repeat(auto-fit, minmax(2ch, 1fr)) !important; */
    grid-template-columns:16px 1fr 16px !important;
    grid-auto-rows: minmax(254px, auto);
  }
  .part3-0 {
    grid-column: 2/2;
    grid-row: 1/2;
    display: flex;
  }
  .part3-1 {
    display: none;
    /* grid-column: 1/2;
  grid-row: 2/2; */
  }
  .part3about {
    margin-top: 0px;
    transform: none;
    /* display: none; */
  }
  .part3Line {
    margin-top: 0px;
    transform: none;
    /* display: none; */
  }
  .part3-2 {
    grid-column: 2/2;
    grid-row: 3/3;
  }
  .part3-5 {
    grid-column: 2/2;
    grid-row: 4/4;
  }
  .infoBlock h3 {
    width: 240px;
    height: 48px;
    margin-right: 36px;
    margin-bottom: 32px;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;

    /* or 150% */
    letter-spacing: 0.1em;

    /* metalix (ligtt,text) */
    color: #36454f;
  }
  .infoBlock img {
    width: 52px;
    height: 48px;
    margin-left: 16px;
    margin-top: -90px;
  }
  .infoBlockP {
    width: 90%;
    min-height: 200px;

    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 24px;
    /* or 200% */
    margin-top: 4px;
    margin-left: 8px;
    letter-spacing: 0.15em;
    text-indent: 24px;
  }
  /******part4 */
  .part4 {
    display: grid;
    grid-template-columns: 1fr;
    grid-auto-rows: minmax(472, auto);
    background: #272d31;
  }
  .part4-1 {
    grid-column: 1/2;
    grid-row: 1/2;
  }
  .part4-2 {
    grid-column: 1/2;
    grid-row: 2/2;
  }

  .part4-3 {
    grid-column: 1/2;
    grid-row: 3/3;
  }
  .part4-4 {
    grid-column: 1/2;
    grid-row: 4/4;
  }

  .part4-5 {
    grid-column: 1/2;
    grid-row: 5/5;
  }
  .part4-6 {
    grid-column: 1/2;
    grid-row: 6/6;
  }
  .part4h {
    width: 328px;
    height: 160px;
    margin-left: 16px;
    margin-top: 32px;
    margin-bottom: 32px;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    letter-spacing: 0.1em;

    /* _Light */
    color: #fbfbfb;
  }
  .part4h3 {
    width: 328px;
    height: 48px;
    margin-bottom: 32px;
    margin-top: 0px;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 24px;
    /* or 200% */
    text-align: left;
    margin-left: 16px;
    margin-right: 16px;
    letter-spacing: 0.15em;
    text-indent: 24px;
  }
  .part4-4 {
    display: none;
  }

  .part4-5 {
    display: none;
  }

  /***part5 */
  .part5line1 {
    width: 64px;
    height: 1px;
    margin-left: 16px;
    margin-top: 39px;

    background: #8fa1ac;
  }
  .part5 {
    display: grid;
    grid-gap: 1rem !important;
    grid-template-columns: repeat(auto-fit, minmax(20ch, 1fr)) !important;
    /* grid-template-columns: 1fr !important;
    grid-auto-rows: minmax(720, auto) !important; */
    background: #f2f6f5;
  }
  .part5-0 {
    grid-column: 1/2 !important;
    grid-row: 1/2 !important;
  }
  .part5-1 {
    /* grid-column: 1/2;
    grid-row: 2/2; */
    display: none !important;
  }

  .part5-2 {
    grid-column: 1/2 !important;
    grid-row: 2/3 !important;
  }

  .part5-3 {
    grid-column: 1/2 !important;
    grid-row: 3/3 !important;
  }

  .part5-4 {
    grid-column: 1/2 !important;
    grid-row: 4/4 !important;
  }
  .part5-5 {
    grid-column: 1/2 !important;
    grid-row: 5/5 !important;
  }
  .part5Title {
    width: 328px;
    height: 168px !important;
    margin-left: 16px !important;
    margin-top: 32px !important;
    margin-bottom: 40px !important;
    font-family: Inter !important;
    font-style: normal !important;
    font-weight: 600 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    /* or 150% */

    letter-spacing: 0.1em !important;

    /* metalix (ligtt,text) */

    color: #36454f;
  }
  .part5Line {
    width: 240px !important;
    height: 4px !important;
    margin-top: 0px !important;
    margin-bottom: 0px;
    margin-left: 16px;
  }
  .part5MiniBlockP {
    margin-left: 16px !important;
  }
  .part5MiniBlockT {
    width: 240px;
    height: 48px;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
  }
  .part5MiniBlockP {
    width: 328px;
    height: 120px;

    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 24px;
    /* or 200% */

    letter-spacing: 0.15em;
    text-indent: 24px;
  }
  .minipart5-4 img {
    width: 52px;
    height: 48px;
    display: block;
    /* text-align: left; */
    margin-left: 125px;
    margin-bottom: 50px;
  }
  /************part6 */
  .part6InfoLine {
    display: none;
  }
  .part6Info {
    width: 237px;
    height: 16px;

    margin: 0px;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 16px;
    /* identical to box height, or 160% */
    margin-top: 32px;
    letter-spacing: 2px;

    /* metalix (ligtt,text) */
    transform: none;
    color: #36454f;
  }
  .part6Line {
    margin: 0;
    display: none;
  }
  .part6Title {
    width: 228px;
    height: 64px;
    margin-left: 0px;
    margin-top: 80px;
    margin-bottom: 32px;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    /* or 133% */

    letter-spacing: 0.1em;

    /* metalix (ligtt,text) */

    color: #36454f;
  }
  .part6Line {
    width: 192px;
    height: 4px;
    margin-bottom: 108px;
    /* _Text */

    background: #233b57;
  }
  .part6 {
    display: grid;
    grid-template-columns: 16px 1fr !important;
    grid-auto-rows: minmax(472, auto);
    background: #fbfbfb;
  }
  .part6-0 {
    grid-column: 2/2;
    grid-row: 1/2;
  }
  .part6-1 {
    /* display: flex; */
    grid-column: 1/2;
    grid-row: 1/4;
  }

  .part6-2 {
    grid-column: 2/2;
    grid-row: 2/2;
  }

  .part6-3 {
    grid-column: 2/2;
    grid-row: 3/3;
  }

  .part6-4 {
    grid-column: 2/2;
    grid-row: 4/4;
    text-align: left;
  }
  .part6-5 {
    grid-column: 2/2;
    grid-row: 5/5;
    text-align: left;
  }
  .part6-6 {
    grid-column: 2/2;
    grid-row: 6/6;
    text-align: left;
  }
  .part6-7 {
    grid-column: 2/2;
    grid-row: 7/7;

    text-align: left;
  }
  .part6-8 {
    grid-column: 2/2;
    grid-row: 8/8;

    text-align: left;
  }
  .part6P {
    width: 328px;
    height: 96px;
    margin-right: 16px !important;
    margin-left: 0px !important;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 24px;
    /* or 200% */
    margin-top: 5px;
    margin-bottom: 50px;
    letter-spacing: 0.15em;
    text-indent: 24px;
  }
  .part6-4 img {
    width: 52px;
    height: 48px;
  }
  .part6-5 img {
    width: 52px;
    height: 48px;
  }
  .part6-6 img {
    width: 52px;
    height: 48px;
  }
  .part6-7 img {
    width: 52px;
    height: 48px;
  }
  .part6-8 img {
    width: 52px;
    height: 48px;
  }
  .part6BlockTitle {
    width: 240px;
    height: 48px;
    margin-top: 16px;
    margin-bottom: 32px;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    /* or 150% */

    letter-spacing: 0.1em;

    /* metalix (ligtt,text) */

    color: #36454f;
  }
  .part6BlockP {
    width: 240px;
    height: 120px;

    margin-top: 0px;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 24px;
    /* or 200% */

    letter-spacing: 0.15em;
    text-indent: 24px;

    /* metalix (ligtt,text) */

    color: #36454f;
  }
  /*****part7 */

  .part7 {
    display: grid;
    grid-gap: 1rem !important;
    grid-template-columns: repeat(auto-fit, minmax(2ch, 1fr)) !important;
    /* grid-template-columns: 1fr !important;
    grid-auto-rows: minmax(772, auto); */
    background: #272d31;
  }
  .part7-0 {
    grid-column: 1/2 !important;
    grid-row: 1/2 !important;
  }
  .part7-1 {
    grid-column: 1/2 !important;
    grid-row: 2/2 !important;
  }

  .part7-2 {
    grid-column: 1/2 !important;
    grid-row: 3/3 !important;
  }

  .part7-3 {
    grid-column: 1/2 !important;
    grid-row: 8/8 !important;
  }

  .part7-4 {
    grid-column: 1/2 !important;
    grid-row: 4/4 !important;
  }
  .part7-5 {
    grid-column: 1/2 !important;
    grid-row: 9/9 !important;
  }
  .part7-6 {
    grid-column: 1/2 !important;
    grid-row: 6/6 !important;
    margin-bottom: 72px;
  }
  .part7-7 {
    grid-column: 1/2 !important;
    grid-row: 7/7 !important;
  }
  .part7-6 img {
    width: 355px;
    height: 316px;
    margin-left: 0px !important;
  }
  .part7-7 img {
    width: 355px;
    height: 316px;
    margin-left: 0px !important;
  }
  .part7Button {
    width: 70%;
    margin-top: 90px;
    margin-bottom: 50px;
    margin-left: 0px !important;
  }
  .part7BI {
    display: none;
  }
  .part7P2 {
    width: 90% !important;
    height: 120px;
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 24px;
    /* or 200% */
    margin-top: 32px;
    margin-left: 16px !important;
    letter-spacing: 0.15em;
    text-indent: 24px;

    /* _Light */

    color: #fbfbfb;
  }
  .part7P {
    width: 328px;
    height: 120px;
    margin-left: 16px !important;
    margin-bottom: 0px !important;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 24px;
    /* or 200% */

    letter-spacing: 0.15em;
    text-indent: 24px;

    /* _Light */

    color: #fbfbfb;
  }
  .part7Title {
    width: 328px !important;
    height: 64px;
    margin-left: 16px !important;
    /* margin-right: 16px !important; */
    margin-top: 40px !important;

    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 32px;
    /* or 133% */

    letter-spacing: 0.1em;

    /* _Light */

    color: #fbfbfb;
  }
  .part7Line {
    width: 64px;
    height: 1px;
    margin-left: 16px;

    margin-top: 39px;
    background: #8fa1ac;
  }
  .part7Button {
    margin: 120px 16px 40px 16px;
  }

  /*****Part 8*******/
  .part8 {
    display: grid;
    grid-template-columns: 1fr;
    grid-auto-rows: minmax(472, auto);
    background: #ffffff;
  }
  .part8-0 {
    grid-column: 1/2;
    grid-row: 1/2;
  }
  .part8-1 {
    grid-column: 1/2;
    grid-row: 2/2;
    display: block;
  }

  .part8-2 {
    grid-column: 1/2;
    grid-row: 3/3;
  }

  .part8-3 {
    grid-column: 1/2;
    grid-row: 4/4;
  }

  .part8-4 {
    grid-column: 1/2;
    grid-row: 5/5;
  }

  .part8-5 {
    grid-column: 1/2;
    grid-row: 6/6;
  }
  .part8Title {
    width: 328px;
    height: 96px;

    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    /* or 150% */

    letter-spacing: 0.1em;
    margin-left: 16px !important;
    /* metalix (ligtt,text) */

    color: #36454f;
  }
  .part8InfoLine {
    display: none;
  }
  .partInfoT {
    width: 56px;
    height: 16px;
    left: 88px;
    top: 0px;

    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 16px;
    /* identical to box height, or 160% */

    letter-spacing: 2px;

    /* metalix (ligtt,text) */
    transform: rotate(0deg);
    color: #36454f;
  }
  .mainImgc {
    width: 360px;
    height: 424px;
  }
  .carouselImg {
    width: 360px;
    height: 424px;
  }
  .part8Line {
    width: 64px;
    height: 1px;
    margin-left: 16px;
    margin-top: 39px;
    margin-bottom: 32px;
    background: #b4c0cf;
  }
  .part8HideInfo {
    display: none;
  }
  /****part11 *****/
  .part11 {
    display: grid;
    grid-gap: 1rem !important;
    grid-template-columns: repeat(auto-fit, minmax(2ch, 1fr)) !important;
    /* grid-template-columns:16px 1fr 16px !important;
    grid-auto-rows: minmax(1136, auto); */
    background: #fafafa;
    margin-top: 0px !important;
  }
  .part11Date {
    display: none;
  }
  .part11Date2 {
    display: none;
  }
  .partInfoLine {
    width: 64px;
    height: 1px;

    margin-top: 39px;
    margin-left: 16px;
    background: #b4c0cf;
  }
  .part11Title {
    width: 328px !important;
    height: 128px !important;
    margin-left: 0px !important;
    margin-bottom: 40px !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    /* or 133% */

    letter-spacing: 0.1em;

    /* metalix (ligtt,text) */

    color: #36454f;
  }
  .part11BTitle {
    width: 252px;
    height: 72px;
    margin-left: 16px;
    /* top: 6864px; */
    text-overflow: ellipsis;
    overflow: hidden;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    /* or 171% */

    letter-spacing: 0.1em;
    text-decoration-line: underline;

    /* _Text */

    color: #233b57;
  }
  .part11BTitle2 {
    width: 252px;
    height: 72px;
    /* top: 6864px; */
    text-overflow: ellipsis;
    overflow: hidden;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    /* or 171% */
    margin-bottom: 0px !important;
    letter-spacing: 0.1em;
    text-decoration-line: underline;
    margin-left: 16px;
    /* _Text */

    color: #233b57;
  }
  .part115Img img {
    width: 328px;
    height: 376px;
  }
  .part11Imargin {
    margin-top: 0px;
  }
  .part11B {
    width: 344px;
  }
  .part11BP {
    width: 328px;
    height: 176px;

    margin-top: 24px;
    margin-left: 16px;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 24px;
    /* or 200% */

    letter-spacing: 0.1em;
    text-indent: 24px;

    /* _Text */

    color: #233b57;
  }
  .part11Line {
    display: none;
  }
  .part11Info {
    width: 63px;
    height: 16px;
    margin-left: 24px;
    margin-top: 32px;
    margin-bottom: 32px;
    transform: none;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    /* identical to box height, or 133% */

    letter-spacing: 2px;

    /* metalix (ligtt,text) */

    color: #36454f;
  }
  .part11InfoLine {
    /* position: absolute; */
    width: 64px;
    height: 10px;
    margin-top: 39px;
    margin-left: 0px;
    background: #b4c0cf;
  }
  .part11BlockLine {
    width: 152px;
    height: 1px;
    margin-left: 16px;

    background: #b4c0cf;
    opacity: 0.32;
  }
  .part11BlockLine2 {
    width: 152px;
    height: 1px;
    margin-left: 16px;

    background: #b4c0cf;
    opacity: 0.32;
  }
  .part11-0 {
    display: none;
  }
  .part11-1 {
    grid-column: 2/3 !important;
    grid-row: 1/2 !important;
    display: flex;
  }
  .part11-2 {
    grid-column: 2/3 !important;
    grid-row: 2/2 !important;
  }
  .part11-3 {
    grid-column: 2/3 !important;
    grid-row: 3/3 !important;
  }
  .part11-4 {
    grid-column: 2/3 !important;
    grid-row: 4/4 !important;
  }

  .part11-5 {
    grid-column: 2/3 !important;
    grid-row: 5/5 !important;
  }
  .part11-6 {
    grid-column: 2/3 !important;
    grid-row: 6/6 !important;
  }
  .part11-7 {
    grid-column: 2/3 !important;
    grid-row: 7/7 !important;
  }

  .part11-8 {
    grid-column: 2/3 !important;
    grid-row: 8/8 !important;
  }
  /*****part12-4*****/
  .part12 {
    display: grid;
    grid-template-columns: 1fr !important;
    grid-auto-rows: minmax(1136, auto);
    background: #36454f;
  }
  .part12-0 {
    grid-column: 1/2 !important;
    grid-row: 1/2 !important;
  }
  .part12-1 {
    grid-column: 1/2 !important;
    grid-row: 2/2 !important;
  }
  .part12-2 {
    grid-column: 1/2 !important;
    grid-row: 3/3 !important;
    display: flex !important;
  }
  .part12-3 {
    grid-column: 1/2 !important;
    grid-row: 4/4 !important;
  }
  .part12-4 {
    grid-column: 1/2 !important;
    grid-row: 5/5 !important;
  }
  .part12-5 {
    grid-column: 1/2 !important;
    grid-row: 6/6 !important;
  }
  .part12-6 {
    grid-column: 1/2 !important;
    grid-row: 7/7 !important;
  }
  .row {
    max-width: 100% !important;
  }
  .part12Infotextarea {
    width: 80% !important;
    margin-left: 40px !important;
    margin-bottom: 35px;
  }
  .part12InfoLine {
   display: none;
   /* width: 328px !important;
    margin-left: 0px !important; */
  }
  .part12InfoButton {
    width: 300px !important;
    margin-left: 0px !important;
  }
  .part12Margin{
    display: none !important;
  }
  .part12InfoMust {
    width: 80% !important;
    height: 48px;
    margin-left: 16px !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 24px;
    /* or 200% */

    letter-spacing: 0.1em;

    /* _Light */

    color: #fbfbfb;
  }
  .part12-3T {
    width: 328px !important;
    height: 128px;

    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    /* or 133% */

    letter-spacing: 0.1em;

    /* _Light */

    color: #fbfbfb;
  }
  .part12-0 {
    display: none;
  }

  .part12-1 {
    display: none;
  }
  .part12-2InfoLine {
    width: 64px;
    height: 1px;
    margin-left: 16px;
    margin-top: 39px;
    transform: none;
    background: #8fa1ac;
  }
  .part12-2Info {
    transform: none;
    width: 120px;
    height: 16px;
    margin-left: 24px !important;
    margin-top: 32px;
    margin-bottom: 32px;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 16px;
    /* identical to box height, or 160% */

    letter-spacing: 2px;

    /* _Light */

    color: #fbfbfb;
  }
  .part12-3T {
    width: 328px;
    height: 128px;
    margin-left: 16px;
    top: 7728px;

    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    /* or 133% */

    letter-spacing: 0.1em;

    /* _Light */

    color: #fbfbfb;
  }
  .part12InfoLine {
    width: 240px !important;
    height: 4px !important;
    margin-left: 16px !important;

    /* _Light */

    background: #fbfbfb !important;
  }
  .part12Checkp {
    width: 240px;
    height: 48px;
    margin-left: 56px;

    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;
    /* or 171% */

    letter-spacing: 0.1em;

    /* _Light */

    color: #fbfbfb;
  }
  #part12Check {
    margin-left: 16px;
  }
  .part12-5 {
    display: none;
  }
  .part12Tp2 {
    width: 288px !important;
    height: 96px;
    margin-left: 40px;
    top: 8576px;

    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    /* or 171% */

    letter-spacing: 0.15em;

    /* _Light */

    color: #fbfbfb;
  }
  /**part13 */
  /************part13 */
  .part13 {
    display: grid;
    grid-template-columns: 16px 1fr !important;
    grid-auto-rows: minmax(1136, auto);
    background: #fbfbfb;
  }
  .part13-0 {
    grid-column: 2/3 !important;
    grid-row: 1/2 !important;
    display: flex !important;
  }
  .part13-1 {
    display: none;
  }
  .part13-2 {
    grid-column: 2/3 !important;
    grid-row: 3/3 !important;
  }
  .part13-3 {
    display: none;
  }
  .part13-4 {
    grid-column: 2/3 !important;
    grid-row: 5/5 !important;
  }
  .part13-5 {
    display: none;
  }

  .part13T {
    width: 328px;
    height: 96px;
    margin-left: 0px;
    margin-bottom: 40px;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    /* or 133% */
    letter-spacing: 0.05em;

    /* metalix (ligtt,text) */

    color: #36454f;
  }
  .part13-4Line {
    width: 240px;
    height: 4px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  .part13AdressInfo {
    margin-top: 36px;
  }
  .part13-4PhoneUl2 {
    margin-left: 0px;
  }
  .mapouter {
    height: 184px;
  }
  .gmap_canvas {
    height: 184px;
  }
  .gmap_iframe {
    width: 375px;
  }
  .part13-4Address {
    width: 240px !important;
    height: 48px;
  }
  .part13-0T {
    width: 61px;
    height: 16px;
    margin-left: 24px;
    margin-top: 32px;
    margin-bottom: 32px;

    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 16px;
    /* identical to box height, or 160% */

    letter-spacing: 2px;

    /* metalix (ligtt,text) */

    color: #36454f;
    transform: none;
  }
  .part13-0L {
    width: 64px;
    height: 1px;
    margin-left: 0px;
    margin-top: 39px;
    margin-bottom: 0px;
    transform: none;
    background: #b4c0cf;
  }
  /*** part11*/
  .part11Title {
    width: 80%;
    height: 128px;

    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    /* or 133% */

    letter-spacing: 0.1em;
    margin-left: 16px !important;
    margin-right: 16px;
    margin-bottom: 40px;
    /* metalix (ligtt,text) */

    color: #36454f;
  }
  .part13-4PhoneUl {
    width: 308px;
  }
  .part13-4mailp {
    width: 228px;
  }
  .part13-4PhoneUl2 {
    width: 328px;
  }
  .socialTag {
    width: 328px;
  }
  .project-text{
    font-size: 22px;
    margin-top: 3rem !important;
    padding-right: 1rem;
    margin-left: 2rem;
  }
  .part2Title2{
    margin-left: 2rem;
    width: 300px;
    height: 40px;
  }
  .part2Title2{
    margin-bottom: 11rem;
  }
}






/* iPads (portrait) ----------- */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  /* Styles **/
  .part12Infotextarea{
    width: 680px !important;
  }
  .mpart1 {
    display: grid;
    grid-template-columns: 80px 1fr 384px;
    grid-auto-rows: minmax(472, auto);
    background: #fbfbfb;
}
.mpart1Title{
  font-size: 50px !important;
  width: 550px;
  margin-bottom: 8rem;
  margin-top: -3rem;
}
.part2{
    display: block;
}
.project-text{
  margin-left: 3rem;
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.part2Title2{
  width: 500px !important;
  margin-left: 40px;
  margin-bottom: 5rem;
}
.part12InfoLine{
  width: 680px;
}
}
/* iPads (portrait and landscape) ----------- */
@media only screen 
and (min-device-width : 768px) 
and (max-device-width : 1024px) {
  /* Styles */
  .miniCarousel{
    margin-left: 5vw;
  }
  .rectangInfo{
    display: none;
  }
  .part2Title{
    font-size: 30px !important;
  }
  .part2Title2{
    font-size: 16px !important;
    width: 250px ;
  }
  .rectang{
    display: none;
  }
  
  .mainTitle{
    font-size: 20px;
    margin-top: -14rem;
    line-height: 40px;
    margin-left: 1rem !important;
  }
  .part1Colum{
    display: none;
  }
  /* .swiper-pagination{
    height: 80px !important;
  }
  .swiper-button-prev{
    margin-top: 4rem !important;
  } */
  .whiteBox{
    margin-top: -30px;
  }
  .part3-0 {
    margin-top: 8rem;
    margin-bottom: 3rem;
}
.part3-1{
  display: none;
}
.home-icon-first{
  width: 70px;
  height: 70px;
}
.infoBlock h3{
  font-size: 24px;
  margin-left: 1rem;
}
.home-section-four{
  margin-top: 2rem;
}
.home-text-third{
  padding-left: 1.5rem;
}
.part5line1{
  margin-top: 38px;
  margin-bottom: 28px !important;
}
.part4h{
    font-family: Inter;
    font-style: normal;
    font-weight: 500 ;
    font-size: 30px;
    line-height: 38px;
    text-align: left;
    letter-spacing: 0.1em;
    width: 100%;
    margin-top: 0px;
    margin-left: 0px;
    margin-bottom: 120px;
    color: #fbfbfb;
}
.part4about{
  display: none;
}
.part4h3{
  margin-left: 0px !important;
  width: 292px;
}
.mobileHide{
  display: none;
}
.part1Margin{
  width: 100% !important;
}
.product-type {
  height: 450px !important;
}
.home-icon{
  height: 80px;

}
.home-icon-1{
  height: 80px;
  margin-top: 1.2rem;;
}
/* .swiper-button-next{
  inset: 80% 0px auto auto !important;
height: 112px !important;
width: 60px !important;
}
.swiper-button-prev{
  top: 67% !important;
} */


.part5 {
  display: grid;
  grid-template-columns: 32px 1fr 32px;
  grid-auto-rows: minmax(472, auto);
  background: #e5e5e5;
}
.part5-0 {
  grid-column: 2/2;
  grid-row: 1/1;
}

.part5-1{
  display: none;
}
.part5-2 {
  grid-column: 2/2;
  grid-row: 2/2;
}

.part5-3 {
  grid-column: 2/2;
  grid-row: 3/3;
}

.part5-4 {
  grid-column: 2/2;
  grid-row: 4/4;
}
.part5-5 {
  grid-column: 2/2;
  grid-row: 5/5;
}
.part5Title{
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 22px;
    line-height: 48px;
    margin-top: 0px;
    margin-left: 40px;
    /* margin-right: 730px; */
    margin-bottom: 96px;
    text-align: left;
    letter-spacing: 0.1em;
    text-indent: 32px;
    color: #36454f;
    width: 625px;
}

.home-section-first{
  display: flex;
  width: 100%;
}
.part5MiniBlockP{
  width: 400px !important;
}

.part6{
    display: grid;
    grid-template-columns: 50px 1fr 50px !important;
    grid-auto-rows: minmax(472, auto);
    background: #fbfbfb;
}
.home-section-icon{
  padding-top: 1.5rem;
}
.part5MiniBlockIcon{
  margin-bottom: 2px !important;
}
.part6-1{
  display: none;
}
.part6-3 {
    grid-column: 2/3;
    grid-row: 3/3;
}
.part6-4 {
     grid-column: 2/3;
    grid-row: 4/4;
}
.part6-5 {
     grid-column: 2/3;
    grid-row: 5/5;
}
.part6-6 {
    grid-column: 2/3;
    grid-row: 6/6;
}
.part6-7 {
   grid-column: 2/3;
    grid-row: 7/7;
}
.part6-8{
    grid-column: 2/3;
    grid-row: 8/8;
}
.part6P {
    width: 696px;
    margin-top: 0px !important;
    text-align: left;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 40px;
    margin-left: 0px;
    letter-spacing: 0.1em;
    text-indent: 32px;
    color: #36454f;
    margin-bottom: 100px;
}
.part6Title {
    width: 543px;
    text-align: left;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 40px;
    line-height: 64px;
    margin-top: 80px;
    margin-bottom: 30px;
    letter-spacing: 0.1em;
    color: #36454f;
}
.part6BlockP{
  width: 100%;
}
.home-text-section{
  margin-left: 4rem;
}
.part7{
  grid-template-columns: 50px 1fr 50px;
}
.part7-0{
  grid-column: 2/3;
grid-row: 2/2;
}
.part7-1{
  grid-column: 2/3;
grid-row: 3/3;
}
.part7-2{
  grid-column: 2/3;
grid-row: 4/4;
}
.part7-3{
  grid-column: 2/3;
grid-row: 5/5;
}
.part7-4{
  grid-column: 2/3;
grid-row: 6/6;
}
.part7-5{
  grid-column: 2/3;
grid-row: 7/7;
}
.part7-6{
  grid-column: 2/3;
grid-row: 8/8;
}
.part7-7{
  grid-column: 2/3;
grid-row: 9/9;
}
.part7Title{
  width: 696px;
  height: 112px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 56px;
  margin: 38px 0px !important;
  letter-spacing: 0.1em;
  color: #fbfbfb;
}
.part7P{
    width: 696px;
    margin-left: 0px;
    height: 120px;
    text-align: left;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 40px;
    margin-top: 8px;
    margin-bottom: 40px;
    letter-spacing: 0.1em;
    text-indent: 32px;
    color: #fbfbfb;
}
.part7Button{
  margin-left: 0px;
  margin-bottom: 4rem;
  margin-right: 1rem;
}
.part7P2{
  margin-bottom: 60px;
}
.part7-6 img{
  height: auto;
 width: 500px;
 margin-right: 1rem;
}
.part7-7 img{
  height: auto;
 width: 500px;
 margin-right: 1rem;
 margin-bottom: 5rem;
}
.part8Line {
    width: 120px;
    height: 1px;
    margin-left: 50px;
    margin-top: 88px;
    margin-bottom: 88px;
    background: #b4c0cf;
}
.part8Title {
    width: 80%;
    height: 96px;
    margin-bottom: 140px;
    margin-left: 50px;
    margin-right: 32px;
    text-align: left;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 28px;
    line-height: 48px;
    letter-spacing: 0.1em;
    text-indent: 32px;
    color: #36454f;
}
.coverImgCarousel img{
  height: auto;
  width: 100%;
}
.part8HideInfo{
  display: none;
}
.part8mainTitle {
    text-align: left;
    position: fixed;
    font-family: Inter;
    font-style: normal;
    font-weight: bold;
    font-size: 30px;
    line-height: 48px;
    z-index: 5;
    width: 600px;
    margin-top: -285px;
    margin-left: 52px;
    letter-spacing: 0.015em;
    text-transform: uppercase;
    color: #fbfbfb;
}
.home-next{
  width: 28px !important;
  inset: 80% 38% auto auto !important;
  height: 100px !important;
}
.part11 {
    display: grid;
    grid-template-columns: 50px 1fr ;
    grid-auto-rows: minmax(1136, auto);
    background: #fafafa;
    margin-top: 0px;
}
.part11-1{
  display: none;
}
.part11-7, .part11-8{
  display: none;
}
.part11B{
  display: none;
}
.part11-5{
  margin: -.5rem;
}
.mainImgc{
  width: 200px;
  height: 300px;
  margin-top: 8rem;;
}
.part11BTitle {
    font-size: 18px;
    margin-right: 1rem;
    margin-left: 1rem;
}
.part11Date2{
  margin-left: 42px !important;
}
.part11BTitle2 {
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 32px;
    height: 128px;
    letter-spacing: 0.1em;
    text-align: left;
    margin-left: 50px;
    margin-top: 32px;
    margin-bottom: 88px;
    color: #233b57;
    width: 100px;
}
.part11BlockLine2{
 margin-left: 0px;
 width: 220px;
}
.part11Date{
  margin-left: 1rem;
}
.part12-2{
  display: none;
}
.part12 {
    
    grid-template-columns: 50px 1fr 1fr 1fr 1fr 1fr;
}
.part12-1Line{
  width: 660px ;

}
#fname{
  width:320px;
  /* margin-left: 2.2rem; */
}
.inputMar {
    margin-left: 120px;
    
}
.part12Infotextarea{
  width: 670px;
  margin-left: 0px;
  /* margin-right: 12rem; */
}
.part12-3T{
  font-size: 22px;
line-height: 38px;
margin-top: -4.5rem;
}
.home-contact-main{
  padding-bottom: 3rem !important;
}
.part12TitleLine{
  display: none;
}
.part12-4{
    grid-column: 2/3;
    grid-row: 3/5;
}
.part12-6, .part12-5{
  display: none !important;
}
.part12InfoButton{
  width: 310px ;
  
}
.part2line-1{
  display: none;
}
.home-contact-inner{
  margin-bottom: 4rem;
}
.part13-0{
  display: none !important;
}
.part13-1{
  display: none;
}
.part13 {
    display: grid;
    grid-template-columns: 50px 1fr 1fr 1fr 1fr 0fr 0fr !important;
    grid-auto-rows: minmax(1136, auto);
    background: #fbfbfb;
}
.part13T{
  margin-top: 3rem;
  font-size: 28px;
  height: 50px;
}
.part13Tp{
  display: none;
}
.part12-1{
  display: none;
}
.part12 {
  display: grid;
  grid-template-columns: 5vw 1fr 5vw !important;
  grid-auto-rows: minmax(1136, auto);
  background: #36454f;
}
.part12-0 {
  grid-column: 2/2 !important;
  grid-row: 1/1 !important;
}
.part12-1 {
  grid-column: 2/2 !important;
  grid-row: 2/2 !important;
}
.part12-2 {
  grid-column: 2/2 !important;
  grid-row: 3/3 !important;
}
.part12-3 {
  grid-column: 2/2;
  grid-row: 2/2;
}
.part12-4 {
  grid-column: 2/2;
  grid-row: 5/5;
}
.part12-5 {
  grid-column: 2/2;
  grid-row: 6/6;
}
.part12-6 {
  grid-column: 2/2;
  grid-row: 7/7;
}
/* .home-icon-next{
      inset: 91% 0px auto 54% !important;
    height: 30px !important;
    width: 30px !important;

} */
}

</style>
